import { abrePDF } from "../../../utils/pdf";
import React, { useState, useEffect, useContext, useMemo } from "react";
import { fDMA } from "../../../utils/fecha";
import "./ListadoPendienteSurtir.css";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  Spinner,
  Form,
  UncontrolledTooltip,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import { encode } from "base64-arraybuffer";
import { ofrecerMailNota as ofrecerMailNotaUtil } from "../../../utils/notaMail";
import axios from "axios";
import Baja from "../../Baja";
import BajaMultiple from "../../BajaMultiple";
import StatusMultipleSurtido from "../../StatusMultipleSurtido";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import AutorizadoMultiple from "../../AutorizadoMultiple";
import CurrencyInput from "react-currency-input-field";

function ListadoPendienteSurtir() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_COLABORADORES = process.env.REACT_APP_URL_COLABORADORES;
  const URL_PEDIDOS = process.env.REACT_APP_URL_PEDIDOS;
  const URL_ARTICULOS_PEDIDO = process.env.REACT_APP_URL_ARTICULOS_PEDIDO;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  const URL_SURTIDOS = process.env.REACT_APP_URL_SURTIDOS;
  const URL_INVENTARIOS = process.env.REACT_APP_URL_INVENTARIOS;
  const URL_ARTICULOS_SURTIDOS = process.env.REACT_APP_URL_ARTICULOS_SURTIDOS;
  const URL_WHATSAPP = process.env.REACT_APP_URL_WHATSAPP;
  const URL_SUCURSALES = process.env.REACT_APP_URL_SUCURSALES;
  const URL_PAQUETERIAS = process.env.REACT_APP_URL_PAQUETERIAS;
  const URL_AREAS = process.env.REACT_APP_URL_AREAS;
  const URL_EMPRESAS = process.env.REACT_APP_URL_EMPRESAS;

  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");

  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState("");

  const [clientesName, setClientesName] = useState([]);
  const [clientesCodigo, setClientesCodigo] = useState([]);
  const [flete, setFlete] = useState(0);
  const [comisionFlete, setComisionFlete] = useState(0);

  const [colaboradores, setColaboradores] = useState([]);
  const [selectedColaborador, setSelectedColaborador] = useState("");
  const [selectedColaboradorSurtido, setSelectedColaboradorSurtido] = useState("");
  const [comision, setComision] = useState(0);
  const [plazo, setPlazo] = useState(0);
  const [areas, setAreas] = useState([]);
  const [selectedArea, setSelectedArea] = useState("");
  const [selectedFechaInicio, setSelectedFechaInicio] = useState("");
  const [selectedFechaFin, setSelectedFechaFin] = useState("");

  const [numero_pedido, setNumeroPedido] = useState("");

  const [inventarios, setInventarios] = useState([]);
  const [idsArticulos, setIdsArticulos] = useState([]);

  const [fecha, setFecha] = useState(hoy);
  const [observaciones, setObservaciones] = useState("NA");
  const [total, setTotal] = useState(0);
  const [totalCajas, setTotalCajas] = useState(0);

  const [salidaBodega, setSalidaBodega] = useState("NA");


  const [selectedPedido, setSelectedPedido] = useState("");
  const [cliente, setCliente] = useState("");

  const [articulosPed, setArticulosPed] = useState([]);
  const [empresas, setEmpresas] = useState([]);
  const [selectedEmpresa, setSelectedEmpresa] = useState("");

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);
  const [validaBoton, setValidaBoton] = useState(true);

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  const [modalEdit, setModalEdit] = useState(false);
  const toggleEdit = () => setModalEdit(!modalEdit);

  const [abrirSurtir, setAbrirSurtir] = useState(false);

  const [impuestos, setImpuestos] = useState("");
  const [comisionTDC, setComisionTDC] = useState(0);


  const [alertasVentasCliente, setAlertasVentasCliente] = useState("No");
  const [selectedClienteTelefono, setSelectedClienteTelefono] = useState("");
  const [vendedor, setVendedor] = useState("");
  const [area, setArea] = useState("");

  const [calle, setCalle] = useState("")
  const [numero_ext, setNumero_ext] = useState("")
  const [numero_int, setNumero_int] = useState("")
  const [estado, setEstado] = useState("")
  const [ciudad, setCiudad] = useState("")
  const [delegacion, setDelegacion] = useState("")
  const [colonia, setColonia] = useState("")
  const [cp, setCp] = useState("")
  const [paqueteria, setPaqueteria] = useState("")
  // W4: edit inline paqueteria/fechaProgramada
  const [modalEditInfo, setModalEditInfo] = useState(false);
  const [editInfoPedidoId, setEditInfoPedidoId] = useState("");
  const [editInfoPaqueteria, setEditInfoPaqueteria] = useState("");
  const [editInfoFechaProg, setEditInfoFechaProg] = useState("");
  const [paqueterias, setPaqueterias] = useState([])
  const [selectedPaqueteria, setSelectedPaqueteria] = useState("")
  const [sucursalesCliente, setSucursalesCliente] = useState([])
  const [selectedSucursal, setSelectedSucursal] = useState("")
  const [RFC, setRFC] = useState("")

  const [modalAreaSurtir, setModalAreaSurtir] = useState(false);
  const toggleAreaSurtir = () => setModalAreaSurtir(!modalAreaSurtir);
  const [descuento, setDescuento] = useState(0);
  const [descuentoNumero, setDescuentoNumero] = useState(0);

  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      articulos: "",
      cantidad: 0,
      cantInv: 0,
      idInv: "",
      idArtPed: "",
      cajas: 0,
      piezasPorCaja: 0,
      precio: 0,
      total: 0,
      pendSurtir: 0,
      cantPed: 0,
      costoUnitario:0
    },
  ]);

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  useMemo(() => {
    axios
      .get(`${URL_PEDIDOS}PendienteSurtir`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allPedidos = response.data;
        // Solo Abiertos, activos, autorizados Y aún no surtidos (los que muestran el botón azul)
        allPedidos = allPedidos.filter(
          (p) =>
            p.is_active === "Si" &&
            (p.status || "Abierto") === "Abierto" &&
            p.autorizadoSurtido === "Si" &&
            p.surtido !== "Si"
        );
        // Array para pagination
        let arrayTabla = allPedidos
          .sort((a, b) => (a.fecha < b.fecha ? 1 : -1))
          .map((a) => {
              return {
                _id: a._id,
                numero: a.idPedido,
                activo: a.is_active,
                fecha: a.fecha,
                colaboradores:
                  a.colaboradores[0].nombre + " " + a.colaboradores[0].apellido,
                idColaboradores: a.colaboradores[0]._id,
                observaciones: a.observaciones,
                total_general: a.total_general,
                clientes: a.clientes[0].nombre_comercial,
                codigo: a.clientes[0].codigo,
                idClientes: a.clientes[0]._id,
                estadoSucursal: a.sucursales?.[0]?.estado || "",
                total_cantidad: a.total_cantidad,
                status: a.status,
                autorizadoApartado: a.autorizadoApartado,
                autorizadoSurtido: a.autorizadoSurtido,
                surtido: a.surtido,
                impuestos: a.impuestos,
                editado: a.editado,
                pdfImpreso: a.pdfImpreso || "No",
                tipoEdicion: a.tipoEdicion,
                comisionFlete: a.comisionFlete,
                comisionTDC: a.comisionTDC,
                calle: a.clientes[0].calle,
                numero_ext: a.clientes[0].numero_ext,
                numero_int: a.clientes[0].numero_int,
                pais: a.clientes[0].pais,
                estado: a.clientes[0].estado,
                ciudad: a.clientes[0].ciudad,
                delegacion: a.clientes[0].delegacion,
                colonia: a.clientes[0].colonia,
                cp: a.clientes[0].cp,
                paqueteria: a.paqueteria || a.clientes[0].paqueteria,
                fecha_programada: a.fecha_programada || "",
                RFC: a.clientes[0].RFC,
                fechaModificado: a.fechaModificado,
                // Día en que se autorizó el surtido (lo sella el back). Los
                // pedidos autorizados antes de que existiera el campo no lo traen.
                fechaConfirmado: a.fechaAutorizadoSurtido || "",
                telefono: a.clientes[0].telefono,
                alertasVentas: a.clientes[0].alertasVentas,
                descuento: a.descuento,
              };
            
          })
          .filter(function (el) {
            return el != null;
          });

        let data = Object.values(arrayTabla);

        setComments(data);

        //
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_CLIENTES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allClientes = response.data;
        setClientes(allClientes);
      })
      .catch((err) => {
        console.log(err);
      });

      axios
      .get(URL_EMPRESAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allEmpresas = response.data;
        setEmpresas(allEmpresas);
        // Default empresa: Ofnoa Parts
        const ofnoa = allEmpresas.find((e) => {
          const nombre = String(e.name || e.empresa || e.razon_social || "").toLowerCase();
          return nombre.includes("ofnoa");
        });
        if (ofnoa) setSelectedEmpresa(ofnoa._id);
      })
      .catch((err) => {
        console.log(err);
      });

      axios
      .get(URL_AREAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allAreas = response.data;
        setAreas(allAreas);
        // Default área: Principal
        const principal = allAreas.find((a) => String(a.name || a.area || "").toLowerCase() === "principal");
        if (principal) setSelectedArea(principal._id);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_COLABORADORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allColaboradores = response.data;
        setColaboradores(allColaboradores);
      })
      .catch((err) => {
        console.log(err);
      });


    axios
      .get(`${URL_INVENTARIOS}SurtirCEDIS`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allInventarios = res.data;
        setInventarios(allInventarios);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [user]);


  function PDFTabla() {
    const data = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (selectedCliente == 0 || selectedCliente == a.idClientes)
      ) {
        return [
          a.activo,
          a.numero,
          a.fecha,
          a.colaboradores,
          a.clientes,
          a.total_cantidad,
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.total_general),
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img = new Image();
    
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 10, 35, 18);
    doc.text(`Listado Pedidos`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [
        [
          "Activo",
          "Numero",
          "Fecha",
          "Vendedor",
          "Cliente",
          "Cantidad",
          "Total",
        ],
      ],
      body: dataPDFLimpia,
 headStyles: {
            fillColor: ["#B02307"],
            lineWidth: 0
          },
          footStyles: {
            fillColor: ["#B02307"],
          },
          theme:"grid",
      startY: 45,
    });
    abrePDF(doc, `Pedidos.pdf`);
  }

  function excel() {
    const dataExcel = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (selectedCliente == 0 || selectedCliente == a.idClientes)
      ) {
        return {
          Activo: a.activo,
          Numero: a.numero,
          Fecha: a.fecha,
          Vendedor: a.colaboradores,
          Cliente: a.clientes,
          Cantidad: a.total_cantidad,
          Total: a.total_general,
        };
      }
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "ListadoPedidos";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ListadoPedidos",
        sheetFilter: [
          "Activo",
          "Numero",
          "Fecha",
          "Vendedor",
          "Cliente",
          "Cantidad",
          "Total",
        ],
        sheetHeader: [
          "Activo",
          "Numero",
          "Fecha",
          "Vendedor",
          "Cliente",
          "Cantidad",
          "Total",
        ],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    const data = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (selectedCliente == 0 || selectedCliente == a.idClientes)
      ) {
        return [
          a.activo,
          a.numero,
          a.fecha,
          a.colaboradores,
          a.clientes,
          a.total_cantidad,
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.total_general),
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img = new Image();
    
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 10, 35, 18);
    doc.text(`Listado Ordenes de Compra`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [
        [
          "Activo",
          "Numero",
          "Fecha",
          "Vendedor",
          "Cliente",
          "Cantidad",
          "Total",
        ],
      ],
      body: dataPDFLimpia,
 headStyles: {
            fillColor: ["#B02307"],
            lineWidth: 0
          },
          footStyles: {
            fillColor: ["#B02307"],
          },
          theme:"grid",
      startY: 45,
    });
    var att = doc.output("arraybuffer");
    var base64File = encode(att);

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado Pedidos",
          email: mailTo,
          fileName: "ListadoPedidos.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Pedidos.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  // D1: genera el PDF de la nota (sin imágenes) y lo manda al cliente.
  // Pregunta antes de enviar y permite capturar/corregir el correo.
  // D1: usa el módulo compartido src/components/utils/notaMail.js
  // (el mismo PDF y correo que manda VentaDirectaCreate).
  async function ofrecerMailNota(surtido, clienteObj, totales = {}) {
    // Vendedor de la venta: recibe copia de la nota
    const vendedorObj = (colaboradores || []).find(
      (c) => c._id === selectedColaboradorSurtido
    );
    const lineas = (inputFields || [])
      .filter((a) => Number(a.cantidad) > 0)
      .map((a) => ({
        codigo: a.articuloCodigo,
        nombre: a.articuloNombre,
        cantidad: a.cantidad,
        precio: a.precio,
        descuento: a.descuento,
        total: a.total,
      }));

    await ofrecerMailNotaUtil({
      datosPDF: {
        numero: surtido?.idSurtido,
        fecha,
        cliente: clienteObj?.nombre_comercial,
        razonSocial: clienteObj?.razon_social,
        observaciones,
        lineas,
        piezas: total,
        subTotal: totales.subTotal,
        iva: totales.iva,
        total: totales.total,
      },
      emailCliente: clienteObj?.email,
      nombreCliente: clienteObj?.nombre_comercial,
      emailVendedor: vendedorObj?.email,
      nombreVendedor: vendedorObj
        ? `${vendedorObj.nombre || ""} ${vendedorObj.apellido || ""}`.trim()
        : "",
      idSurtido: surtido?._id,
      urlSurtidos: URL_SURTIDOS,
      urlSendMailAtt: URL_SEND_MAIL_ATT,
    });
  }
  // PDF de peso del PEDIDO (equivalente al de ListadoVentas, pero sobre lo
  // que está pendiente de surtir, que es lo que se va a embarcar).
  async function PDFPeso(idPedido, numero, clienteName, fecha, area) {
    try {
      const res = await axios.get(`${URL_ARTICULOS_PEDIDO}/surtir2/${idPedido}`, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      });
      const filas = (res.data || [])
        .filter((a) => a?.articulos?.[0])
        .map((a) => {
          const art = a.articulos[0];
          // Se pesa lo pendiente de surtir; si ya no hay pendiente, la línea
          // no entra (ya se embarcó en otra remisión).
          const cantidad = Number(a.pendiente_surtir || 0);
          const pesoPieza = Number(art.pesoPieza || 0);
          const pesoCaja = Number(art.pesoCaja || 0);
          const pxc = Number(art.piezasPorCaja || 1) || 1;
          return {
            idArticulo: art._id,
            codigo: art.codigo || "",
            nombre: art.nombre || "",
            cantidad,
            cajas: cantidad / pxc,
            pesoPieza,
            pesoCaja,
            pesoTotal: cantidad * pesoPieza,
          };
        })
        .filter((f) => f.cantidad > 0);

      if (!filas.length) {
        Swal.fire({
          icon: "info",
          title: "Sin pendiente",
          text: "Este pedido no tiene piezas pendientes de surtir.",
        });
        return;
      }

      // Agrupar por artículo
      const grupos = {};
      for (const f of filas) {
        const id = String(f.idArticulo);
        grupos[id] = grupos[id] || { ...f, cantidad: 0, cajas: 0, pesoTotal: 0 };
        grupos[id].cantidad += f.cantidad;
        grupos[id].cajas += f.cajas;
        grupos[id].pesoTotal += f.pesoTotal;
      }
      const rows = Object.values(grupos)
        .sort((a, b) => (a.codigo || "").localeCompare(b.codigo || ""))
        .map((g) => [
          g.codigo,
          g.nombre,
          new Intl.NumberFormat("en-US").format(g.cantidad),
          new Intl.NumberFormat("en-US", { maximumFractionDigits: 2 }).format(g.cajas),
          new Intl.NumberFormat("en-US", { maximumFractionDigits: 3 }).format(g.pesoPieza) + " kg",
          new Intl.NumberFormat("en-US", { maximumFractionDigits: 3 }).format(g.pesoCaja) + " kg",
          new Intl.NumberFormat("en-US", { maximumFractionDigits: 3 }).format(g.pesoTotal) + " kg",
        ]);
      const totalPiezas = Object.values(grupos).reduce((t, g) => t + g.cantidad, 0);
      const totalCajas = Object.values(grupos).reduce((t, g) => t + g.cajas, 0);
      const totalPeso = Object.values(grupos).reduce((t, g) => t + g.pesoTotal, 0);

      // Carta, igual que la hoja de surtido (ver PDFOC)
      const doc = new jsPDF("portrait", "mm", "letter", true);
      const img = new Image();
      img.src = process.env.PUBLIC_URL + "logoInstitucion.png";
      doc.addImage(img, "png", 15, 8, 33, 20);
      doc.setFontSize(12);
      doc.text(`Pendiente de Surtir por Peso`, 105, 20, { align: "center" });
      doc.setFontSize(9);
      doc.text(`Cliente: ${clienteName || ""}`, 15, 34);
      doc.text(`Pedido: ${numero || ""}   Fecha: ${fecha || ""}   Área: ${area || ""}`, 15, 40);

      doc.autoTable({
        head: [["Código", "Descripción", "Cantidad", "Cajas", "Peso Pieza", "Peso Caja", "Peso Total"]],
        body: rows,
        startY: 45,
        theme: "grid",
        margin: { bottom: 18 },
        rowPageBreak: "avoid",
        styles: { fontSize: 8 },
        headStyles: { fillColor: [176, 35, 7], textColor: 255, halign: "center", fontSize: 8 },
        columnStyles: {
          2: { halign: "right" },
          3: { halign: "right" },
          4: { halign: "right" },
          5: { halign: "right" },
          6: { halign: "right" },
        },
        foot: [[
          "", "Totales",
          new Intl.NumberFormat("en-US").format(totalPiezas),
          new Intl.NumberFormat("en-US", { maximumFractionDigits: 2 }).format(totalCajas),
          "", "",
          new Intl.NumberFormat("en-US", { maximumFractionDigits: 3 }).format(totalPeso) + " kg",
        ]],
        footStyles: { fillColor: [176, 35, 7], textColor: 255, fontSize: 8 },
      });
      abrePDF(doc, `Peso-Pedido-${numero || idPedido}.pdf`);
    } catch (err) {
      console.log(err);
      Swal.fire({ icon: "error", title: "Error", text: "No se pudo generar el PDF de peso" });
    }
  }

  // Visor del pedido en modal, sin descargar ni marcarlo como impreso
  const [pedidoPreview, setPedidoPreview] = useState(null);
  const cerrarPedidoPreview = () => setPedidoPreview(null);

  // Los mismos 31 argumentos que ya reciben los botones de PDF, en orden.
  // Sirve para el botón de "ver" sin repetir la lista otra vez.
  const argsPDFOC = (a) => [
    a.fecha, a.colaboradores, a.idClientes, a.clientes, a.total_cantidad,
    a.total_general, a.observaciones, a.numero, a.impuestos, a.comisionFlete,
    a.comisionTDC, a._id, a.calle, a.numero_ext, a.numero_int, a.pais,
    a.estado, a.ciudad, a.delegacion, a.colonia, a.cp, a.RFC, a.paqueteria,
    a.codigoClientes, a.autorizadoApartado, a.autorizadoSurtido, a.telefono,
    a.editado, a.editPedido, a.autorizoApartado, a.autorizoSurtido,
  ];

  async function PDFOC(
    fecha,
    colaboradores,
    idClientes,
    clientes,
    total_cantidad,
    total_general,
    observaciones,
    numero,
    impuestos,
    comisionFlete,
    comisionTDC,
    idPDFOC,
    calle,
    numero_ext,
    numero_int,
    pais,
    estado,
    ciudad,
    delegacion,
    colonia,
    cp,
    RFC,
    paqueteria,
    codigoClientes,
    autorizadoApartado,
    autorizadoSurtido,
    telefono,
    editado,
    editPedido,
    autorizoApartado,
    autorizoSurtido,
    soloVer = false
  ) {
    await axios
      .get(`${URL_ARTICULOS_PEDIDO}/surtir2/${idPDFOC}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        const allArticulosPedido = response.data || [];
        const dataFinal = allArticulosPedido.map((a) => ({
          articulos: (a.articulos?.[0]?.codigo || "") + " " + (a.articulos?.[0]?.nombre || ""),
          nombreArticulo: a.articulos?.[0]?.nombre || "",
          linea: a.articulos?.[0]?.lineas?.[0]?.name || "",
          subLinea: a.articulos?.[0]?.subLineas?.[0]?.name || "",
          cantidad: parseFloat(a.cantidad) || 0,
          surtido: parseFloat(a.surtido) || 0,
          pendiente_surtir: parseFloat(a.pendiente_surtir) || 0,
          cajas: a.articulos?.[0]?.piezasPorCaja > 0
            ? (parseFloat(a.cantidad) || 0) / parseFloat(a.articulos[0].piezasPorCaja)
            : 0,
          // Renglón que se modificó al editar el pedido (se pinta de amarillo)
          editado: a.editado || "No",
        }));

        // Mismo orden que Lista PDF de ListadoPedidos (Z4): Categoría → SubCategoría → nombre
        dataFinal.sort((a, b) => {
          if (a.linea !== b.linea) return (a.linea || "").localeCompare(b.linea || "");
          if ((a.subLinea || "") !== (b.subLinea || "")) return (a.subLinea || "").localeCompare(b.subLinea || "");
          return (a.nombreArticulo || "").localeCompare(b.nombreArticulo || "");
        });

        const totalPzas = dataFinal.reduce((acc, c) => acc + c.cantidad, 0);
        const totalCajas = dataFinal.reduce((acc, c) => acc + c.cajas, 0);

        if (soloVer) {
          // Sólo se consulta: se muestra en tabla, no cuenta como impreso ni
          // limpia el amarillo. Ver el pedido no es sacarlo para surtir.
          setPedidoPreview({
            numero, fecha, clientes, codigoClientes, colaboradores,
            paqueteria, observaciones, filas: dataFinal, totalPzas, totalCajas,
          });
          return;
        }

        const body = dataFinal.map((a) => [
          a.articulos,
          new Intl.NumberFormat("en-US").format(a.cantidad),
          new Intl.NumberFormat("en-US", { maximumFractionDigits: 2 }).format(a.cajas),
          new Intl.NumberFormat("en-US").format(a.surtido),
          new Intl.NumberFormat("en-US").format(a.pendiente_surtir),
        ]);

        // Tamaño CARTA: es el papel que usa almacén. Antes salía en A4 (297 mm)
        // y al imprimir en carta (279 mm) se perdía el último renglón de cada
        // página: en el pedido 560 no se surtieron CAR-008 ni ZAP-004 porque
        // nunca salieron en el papel.
        const doc = new jsPDF({ format: "letter" });
        doc.setFont("helvetica", "normal");
        doc.setTextColor(0, 0, 0);

        // Encabezado simple
        doc.setFontSize(14);
        doc.text(`Pedido # ${numero}`, 14, 18);
        doc.setFontSize(10);
        doc.text(`Fecha: ${fecha}`, 14, 26);
        doc.text(`Cliente: ${codigoClientes ? codigoClientes + " - " : ""}${clientes || ""}`, 14, 32);
        doc.text(`Vendedor: ${colaboradores || ""}`, 14, 38);
        if (paqueteria) doc.text(`Paqueteria: ${paqueteria}`, 14, 44);
        const obsText = `Observaciones: ${observaciones || "NA"}`;
        const obsLines = doc.splitTextToSize(obsText, 180);
        doc.text(obsLines, 14, paqueteria ? 50 : 44);

        const startY = (paqueteria ? 50 : 44) + obsLines.length * 5 + 4;

        // Índices de los artículos modificados (mismo orden que `body`)
        const filasEditadas = new Set();
        dataFinal.forEach((d, i) => {
          if (d.editado === "Si") filasEditadas.add(i);
        });

        doc.autoTable({
          head: [["Articulo", "Cantidad", "Cajas", "Surtido", "Pend. Surtir"]],
          body,
          startY,
          theme: "grid",
          styles: { fontSize: 9, textColor: [0, 0, 0], lineColor: [0, 0, 0], lineWidth: 0.1 },
          headStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], fontStyle: "bold", lineWidth: 0.1, lineColor: [0, 0, 0] },
          // Margen de abajo amplio (la impresora no imprime el borde) y un
          // renglón nunca se parte entre dos páginas: si no cabe completo, se
          // va entero a la siguiente con su código y cantidades.
          margin: { left: 14, right: 14, bottom: 18 },
          rowPageBreak: "avoid",
          showHead: "everyPage",
          // Pinta de amarillo los artículos que sufrieron modificación
          didParseCell: function (data) {
            if (
              data.cell.section === "body" &&
              filasEditadas.has(data.row.index)
            ) {
              data.cell.styles.fillColor = [255, 230, 128];
            }
          },
        });

        let finalY = doc.autoTable.previous.finalY + 6;
        // Si el total ya no cabe arriba del margen, va en una página nueva
        if (finalY > doc.internal.pageSize.getHeight() - 18) {
          doc.addPage();
          finalY = 20;
        }
        doc.setFontSize(10);
        doc.text(
          `Total: ${new Intl.NumberFormat("en-US").format(totalPzas)} piezas / ${new Intl.NumberFormat("en-US", { maximumFractionDigits: 2 }).format(totalCajas)} cajas / ${dataFinal.length} renglones`,
          14,
          finalY
        );

        // Pie en cada página: almacén puede comprobar que tiene todas las
        // hojas y que el número de renglones cuadra con lo que va a surtir.
        const paginas = doc.internal.getNumberOfPages();
        for (let pg = 1; pg <= paginas; pg++) {
          doc.setPage(pg);
          doc.setFontSize(8);
          doc.text(
            `Pedido # ${numero} · Página ${pg} de ${paginas} · ${dataFinal.length} renglones`,
            doc.internal.pageSize.getWidth() / 2,
            doc.internal.pageSize.getHeight() - 10,
            { align: "center" }
          );
        }

        abrePDF(doc, `Pedido-${numero}.pdf`);

        // Ya se imprimió el PDF con los renglones modificados en amarillo:
        // se quita la marca de "modificado" del pedido y de sus artículos
        // para que el listado deje de pintarse y el próximo PDF salga limpio.
        limpiarMarcaModificado(idPDFOC, allArticulosPedido);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  // Botón "regresar a azul": el pedido vuelve a quedar como recién autorizado
  // (pendiente de imprimir, sin marca de modificado ni en sus líneas).
  async function regresarAAzul(a) {
    const r = await Swal.fire({
      title: `¿Regresar el pedido #${a.numero} a azul?`,
      text: "Vuelve a quedar como pendiente de imprimir: se quita la marca de impreso y la de modificado.",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Sí, a azul",
      cancelButtonText: "Cancelar",
    });
    if (!r.isConfirmed) return;
    const headers = { Authorization: `Bearer: ${localStorage.getItem("app_token")}` };
    try {
      await axios.patch(`${URL_PEDIDOS}/${a._id}`, { editado: "No", pdfImpreso: "No" }, { headers });
      const lineas = await axios.get(`${URL_ARTICULOS_PEDIDO}/surtir2/${a._id}`, { headers });
      const marcadas = (lineas.data || []).filter((l) => l?.editado === "Si");
      await Promise.all(
        marcadas.map((l) => axios.patch(`${URL_ARTICULOS_PEDIDO}/${l._id}`, { editado: "No" }, { headers }))
      );
      setComments((prev) =>
        (prev || []).map((c) => (c._id === a._id ? { ...c, editado: "No", pdfImpreso: "No" } : c))
      );
      axios
        .post(URL_LOGS, { tipo: "Pedido a azul", detalle: `Pedido ${a.numero} ${a.clientes}`, user: user.id }, { headers })
        .catch(() => {});
    } catch (err) {
      console.log("[regresarAAzul]", err);
      Swal.fire({ icon: "error", title: "No se pudo", text: "No se pudo regresar el pedido a azul" });
    }
  }

  // Quita `editado` del pedido y de las líneas que lo traían marcado.
  async function limpiarMarcaModificado(idPedido, articulosPedido = []) {
    const headers = { Authorization: `Bearer: ${localStorage.getItem("app_token")}` };
    try {
      // Sólo `editado`: el validator no acepta tipoEdicion vacío, y el color
      // del renglón se decide por `editado`, así que con eso basta.
      // Además de limpiar "editado", queda constancia de que ya se imprimió:
      // con eso el renglón deja de salir en azul.
      await axios.patch(
        `${URL_PEDIDOS}/${idPedido}`,
        { editado: "No", pdfImpreso: "Si" },
        { headers }
      );
      // Limpiar sólo las líneas marcadas, para no escribir de más
      const marcadas = (articulosPedido || []).filter((a) => a?.editado === "Si");
      await Promise.all(
        marcadas.map((a) =>
          axios.patch(`${URL_ARTICULOS_PEDIDO}/${a._id}`, { editado: "No" }, { headers })
        )
      );
      // Refleja el cambio en la tabla sin recargar la página
      setComments((prev) =>
        (prev || []).map((c) =>
          c._id === idPedido ? { ...c, editado: "No", pdfImpreso: "Si" } : c
        )
      );
    } catch (err) {
      console.log("[limpiarMarcaModificado]", err);
    }
  }

//   function enviaMailImpuesto(
//      numero,
//     fechaHora,
//   ) {
// let fechaHora2 = moment(fechaHora).format('YYYY-MM-DD');
//     const dataIF = inputFields.map((a) => {
//       if(a.cantidad > 0){
//             return {
//               cantidad: a.cantidad,
//               articulos: a.articulos,
//               articuloNombre: a.articulosNombre,
//               cajas: a.cantidad / a.piezasPorCaja,
//               idArticulo: a.idArtPed,
//               precio: a.precio,
//               piezasPorCaja: a.piezasPorCaja
//             }
//             }
//           })
//           .filter(function (el) {
//             return el != null;
//           });

//         let dataFinal = Object.values(dataIF);

//         let TC = dataFinal.map((c) => parseFloat(c.cajas));
//         let total_cantidad = dataFinal.map((c) => c.cantidad);

//         let iva = 0;
//         let total_general = 0;

//         let STotal = inputFields.map((c) => parseFloat(c.total));
//         let subTotal = STotal.reduce((t, total, index) => t + total, 0);

//         if (impuestos != 0) {
//           iva = (impuestos * subTotal) / 100;
//         } else {
//           iva = 0;
//         }

//         total_general = (impuestos * subTotal) / 100 + subTotal + comisionFlete + comisionTDC;

//         let totalParcial = 0;

//         const data = dataFinal.map((a) => {
//           totalParcial = a.cantidad * a.precio;
//           return [
//             new Intl.NumberFormat("en-US").format(a.cantidad),
//             codigoArticulo,
//             articuloNombre,
//             new Intl.NumberFormat("en-US").format(a.cajas.toFixed(2)),
//             new Intl.NumberFormat("en-US", {
//               style: "currency",
//               currency: "USD",
//               maximumFractionDigits: 2,
//             }).format(a.precio),
//             new Intl.NumberFormat("en-US", {
//               style: "currency",
//               currency: "USD",
//               maximumFractionDigits: 2,
//             }).format(totalParcial),
//           ];
//         });

//         const dataPDF = Object.values(data);
//         const dataPDFLimpia = dataPDF.filter(function (el) {
//           return el != null;
//         });

//          const columnStyles = [
//         { fontSize: 9,textColor: ["#000000"] },
//         { fontSize: 9,textColor: ["#000000"] },
//         { fontSize: 9,textColor: ["#000000"] },
//         { fontSize: 9,textColor: ["#000000"] },
//         { fontSize: 9,textColor: ["#000000"] ,halign: 'right'},
//         { fontSize: 9,textColor: ["#000000"] ,halign: 'right'},
//         ];
        
//       const doc = new jsPDF({compressPdf: true});
//         var img = new Image();
//         var img2 = new Image();
//         const backgroundColor = ["#d1d2d4"];
//         const backgroundColorBoxLightGray = ["#e6e7e9"];
//         const backgroundColorBoxBlack = ["#231f20"];
//         const backgroundColorBoxPurple = ["#B02307"];
//         const margins = {  left: 5, right: 5 };

//       img.src = process.env.PUBLIC_URL + "logoInstitucion.jpg";
//       doc.addImage(img, "jpg", 15, 5, 33, 33);

//       // img.src = process.env.PUBLIC_URL + "marcas.jpg";
//       // doc.addImage(img, "jpg", 9, 28, 192, 10);
//       // doc.setFontSize(10);
      
//       doc.setFillColor(...backgroundColor);
//       doc.rect(5, 40, 200, 6, 'F');
//       doc.setTextColor("#000000");
//       doc.text(`Tel: 55 1234 5678`,8, 44);

//       doc.setTextColor("#000000");
//       doc.text(`Cliente: ${clientesCodigo} - ${clientesName}`,8, 52);
//       doc.text(`Remisión: ${numero}`,80, 52);
//       doc.text(`Pedido: ${numero_pedido}`,160, 52);

//       doc.setTextColor("#B02307");
//       doc.setFontSize(12);
//       doc.setFont('helvetica', 'bold');
//       doc.text(`macuro.mx`,175, 44);
//       doc.setTextColor("#000000");

//       doc.setFontSize(14);
//       doc.setFillColor(...backgroundColorBoxBlack);
//       doc.rect(100, 4, 105, 22, 'F');
//       doc.setFillColor(...backgroundColorBoxPurple);
//       doc.rect(74, 4, 25, 22, 'F');
//       doc.setTextColor("#ffffff");
//       doc.text(`NOTA DE SALIDA`,125, 12);
//       doc.setFont('helvetica', 'normal');
//       doc.text(`SALIDA BODEGA`,125, 17);
//       doc.text(`México, D. F. a ${fechaHora2}`,125, 22);
        
//         doc.autoTable({
//           head: [[
//               "CANTIDAD",
//               "MODELO",
//               "DESCRIPCION",
//               "BULTO#",
//               "PRECIO UNITARIO",
//               "IMPORTE",
//             ]],
//           body: dataPDFLimpia,
//           styles: {
//             fontSize: 10,
//             overflow: "linebreak",
//             columnWidth: "wrap",
//             overflowColumns: "linebreak",
//           },
//           headStyles: {
//             fillColor: ["#B02307"],
//             lineWidth: 0,
//             halign: 'center',
//             valign: 'middle',
//             fontSize: 8
//           },
//           footStyles: {
//             fillColor: ["#B02307"],
//           },
//           columnStyles: columnStyles,
//           theme:"grid",
//           margin: { left: 5, right: 5 },
//           startY: 55,
//           showFoot: "lastPage",
//         });

//         doc.setFillColor(...backgroundColorBoxPurple);
//         doc.rect(5, doc.autoTable.previous.finalY +1, 36, 6, 'F');
//         doc.setTextColor("#ffffff");
//         doc.setFontSize(8);
//         doc.text(`TOTAL DE ARTICULOS`,7,  doc.autoTable.previous.finalY+5);
//         doc.setTextColor("#000000");
//         doc.text(`________________________________________________________________________________________________________________________________`,5,  doc.autoTable.previous.finalY+22);

//         doc.setFillColor(...backgroundColorBoxLightGray);
//         doc.setFont('helvetica', 'normal');
//         doc.rect(40, doc.autoTable.previous.finalY +1, 40, 6, 'F');
//         doc.text(new Intl.NumberFormat("en-US").format(total_cantidad) + " Piezas",42,  doc.autoTable.previous.finalY+5);

//         doc.setFontSize(7.5);
//         doc.text(`1. Esta es una venta en firme y no se acepta ningún tipo de descuento o devolución sin consentimiento previo.`,5,  doc.autoTable.previous.finalY+11);
//         doc.text(`2. La mercancía viaja por cuenta y riesgo del cliente, no somos responsables por faltante.`,5,  doc.autoTable.previous.finalY+14);
//         doc.text(`3. El pago de la mercancía debe realizarse en tiempo y forma pactados a la cuenta proporcionada por nosotros.`,5,  doc.autoTable.previous.finalY+17);

//         var nota = "Debo(emos)  y pagare(mos)  incondicionalmente por  este  pagare a la orden  de MACURO en esta plaza,  el día estipulado en  este documento,  la cantidad estipulada  en este  documento,  valor recibido a  mi entera satisfacción, este pagare causará intereses a razón de 2% mensual a partir de la fecha de vencimiento, hasta su total liquidación, pagadero conjuntamente con el principal. Este pagare se rige en los términos de ley general de títulos y operaciones de crédito.";
//         var lines = doc.splitTextToSize(nota, 129);
//         doc.text(5,doc.autoTable.previous.finalY + 26, lines);

//         doc.setFillColor(...backgroundColorBoxPurple);
//         doc.rect(144, doc.autoTable.previous.finalY +1, 37, 6, 'F');
//         doc.setTextColor("#ffffff");
//         doc.setFont('helvetica', 'bold');
//         doc.setFontSize(8);
//         doc.text(`SUBTOTAL $`,153,  doc.autoTable.previous.finalY+5);

//         doc.setFillColor(...backgroundColorBoxLightGray);
//         doc.setTextColor("#000000");
//         doc.setFont('helvetica', 'normal');
//         doc.rect(181, doc.autoTable.previous.finalY +1, 24, 6, 'F');
//         doc.text(new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format((subTotal).toFixed(2)),183,  doc.autoTable.previous.finalY+5);

//         doc.setFillColor(...backgroundColorBoxPurple);
//         doc.rect(144, doc.autoTable.previous.finalY +8, 37, 6, 'F');
//         doc.setTextColor("#ffffff");
//         doc.setFont('helvetica', 'bold');
//         doc.setFontSize(8);
//         doc.text(`IMPUESTO $`,154,  doc.autoTable.previous.finalY+12);

//         doc.setFillColor(...backgroundColorBoxLightGray);
//         doc.setTextColor("#000000");
//         doc.setFont('helvetica', 'normal');
//         doc.rect(181, doc.autoTable.previous.finalY +8, 24, 6, 'F');
//         doc.text(new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format((iva).toFixed(2)),183,  doc.autoTable.previous.finalY+12);

//         doc.setFillColor(...backgroundColorBoxPurple);
//         doc.rect(144, doc.autoTable.previous.finalY +15, 37, 6, 'F');
//         doc.setTextColor("#ffffff");
//         doc.setFont('helvetica', 'bold');
//         doc.setFontSize(8);
//         doc.text(`TOTAL $`,159,  doc.autoTable.previous.finalY+19);

//         doc.setFillColor(...backgroundColorBoxLightGray);
//         doc.setTextColor("#000000");
//         doc.setFont('helvetica', 'normal');
//         doc.rect(181, doc.autoTable.previous.finalY +15, 24, 6, 'F');
//         doc.text(new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(parseFloat(total_general).toFixed(2)),183,  doc.autoTable.previous.finalY+19);

//         var lines = doc.splitTextToSize(`Observaciones: ${observaciones}`, 40);
//         doc.text(145,doc.autoTable.previous.finalY + 26, lines);

//         doc.setFont('helvetica', 'bold');
//         doc.text(`Nombre Completo:__________________________________________________________________________  Firma:______________________________`,5,  doc.autoTable.previous.finalY+50);

//         doc.setFont('helvetica', 'normal');
//         doc.setFontSize(6);
//         doc.text(`ESTE DOCUMENTO NO REPRESENTA UN COMPROBANTE FISCAL`,67,  doc.autoTable.previous.finalY+60);
// // abrePDF(doc, `Nota-${numero}.pdf`);

//       var att = doc.output("arraybuffer");
//       var base64File = encode(att);
//       axios
//       .post(
//         URL_SEND_MAIL_ATT,
//         {
//           subject: "Solicitud de factura",
//           email: process.env.REACT_APP_MAIL_ITMACURO,
//           fileName: `Nota-${numero}.pdf`,
//           att: base64File,
//           text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
//          <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
//          <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
//          <tbody>
//          <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
//          <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Le solicitamos la realizar la factura con la informacion adjunta.</tr>
//          </tbody>
//          <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         
//          </table>`,
//         },
//         {
//           headers: {
//             Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
//           },
//         }
//       )
//       .then(() => {
//         console.log('email enviado')
//         Swal.fire("Good job!", "Enviado con exito", "success");
//       })
//       .catch((error) => {
//         console.log('email error')
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: "Something went wrong!",
//         });
//         console.log(error);
//       });
//   }

async  function excelOC(
    idPDFOC,
    clientes,
    ) {

      await axios
      .get(`${URL_ARTICULOS_PEDIDO}/surtir/${idPDFOC}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulosPedido = response.data.AP;
        let allInventarios = response.data.AI;

        let allInventarios2 = allInventarios
          .map((a) => {
            return {
              idArticulo: a.articulos[0]._id,
              codigo: a.articulos[0].codigo,
              articulo: a.articulos[0].nombre,
              cantidadInventario: a.cantidad,
              cantidadPedido: 0,
              surtido: 0,
              pendiente_surtir: 0,
              cajas: 0,
              piezasPorCaja: a.articulos[0].piezasPorCaja,
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataInv = Object.values(allInventarios2);

        let agrupado = dataInv
          .reduce(function (groups, item) {
            const val = item["idArticulo"];
            groups[val] = groups[val] || {
              idArticulo: item.idArticulo,
              cajas: 0,
            };
            groups[val].articulo = item.articulo;
            groups[val].codigo = item.codigo;
            groups[val].cantidadPedido = item.cantidadPedido;
            groups[val].surtido = item.surtido;
            groups[val].pendiente_surtir = item.pendiente_surtir;
            groups[val].cajas = item.cajas;
            groups[val].piezasPorCaja = item.piezasPorCaja;
            return groups;
          }, []);

        let dataAgrupado = Object.values(agrupado);

        let allArticulosPedido2 = allArticulosPedido
          .map((a) => {
            return {
              codigo: a.articulos[0].codigo,
              articulo: a.articulos[0].nombre,
              idArticulo: a.articulos[0]._id,
              cantidadPedido: a.cantidad,
              surtido: a.surtido,
              pendiente_surtir: a.pendiente_surtir,
              cajas:
                parseFloat(a.pendiente_surtir) /
                parseFloat(a.articulos[0].piezasPorCaja),
              piezasPorCaja: a.articulos[0].piezasPorCaja,
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataPedidos = Object.values(allArticulosPedido2);



    const dataExcel = dataPedidos.map((a) => {
        return {
          Cliente: clientes,
          Codigo: a.codigo,
          Articulo: a.articulo,
          PzsCaja: a.piezasPorCaja,
          Cajas: a.cajas,
          PendSurtir: a.pendiente_surtir,
        };
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "DesglocePedido";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "DesglocePedido",
        sheetFilter: [
        "Cliente",
        "Codigo",
        "Articulo", 
        "PzsCaja", 
        "Cajas", 
        "PendSurtir", 
        ],
        sheetHeader: [
        "Cliente",
        "Codigo",
        "Articulo", 
        "PzsCaja", 
        "Cajas", 
        "PendSurtir", 
        ],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  
    })
    .catch((err) => {
      console.log(err);
    });
  }

  // Número del pedido; si trae renglones en $0 se marca aquí mismo para que se
  // vea cuál es el que no va a poder surtirse.
  function celdaNumero(a) {
    const malo = sinPrecioDe(a._id);
    if (!malo) return a.numero;
    return (
      <>
        {a.numero}{" "}
        <span
          id={`cero-${a._id}`}
          style={{
            background: "#dc3545",
            color: "#fff",
            borderRadius: 10,
            padding: "1px 7px",
            fontSize: 11,
            fontWeight: 700,
            whiteSpace: "nowrap",
          }}
        >
          $0
        </span>
        <UncontrolledTooltip placement="top" target={`cero-${a._id}`}>
          Sin precio: {malo.articulos.map((x) => x.codigo).join(", ")}. Captura el precio en
          el pedido para poder surtirlo.
        </UncontrolledTooltip>
      </>
    );
  }

  // Fecha en que se confirmó el pedido; si es un pedido viejo sin ese dato se
  // muestra la última modificación, marcada para que no se confunda.
  function celdaConfirmado(a) {
    if (a.fechaConfirmado) return fDMA(a.fechaConfirmado);
    return (
      <span title="Pedido autorizado antes de que se guardara la fecha de confirmación; se muestra la última modificación">
        {fDMA(a.fechaModificado)}
        <br />
        <small style={{ color: "#888" }}>últ. mod.</small>
      </span>
    );
  }

  const headers = [
    // { name: "Activo", field: "activo", sortable: true },
    { name: "Numero", field: "numero", sortable: true },
    { name: "Confirmado", field: "fechaConfirmado", sortable: true },
    { name: "Cliente", field: "clientes", sortable: true },
    { name: "Estado", field: "estadoSucursal", sortable: true },
    { name: "Vendedor", field: "colaboradores", sortable: true },
    { name: "Fecha Prog", field: "fecha_programada", sortable: true },
    { name: "Paqueteria", field: "paqueteria", sortable: true },
    { name: "PDF", field: "pdf", sortable: false },
    { name: "Surtir", field: "surtir", sortable: false },
    { name: "Surtido", field: "surtido", sortable: false },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.colaboradores.toLowerCase().includes(search.toLowerCase()) ||
          comment.clientes.toLowerCase().includes(search.toLowerCase()) ||
          comment.total_cantidad.toString().includes(search) ||
          comment.numero.toString().includes(search)
      );
    }
    if (selectedCliente) {
      computedComments = computedComments.filter((e) =>
        e.idClientes.includes(selectedCliente)
      );
    }
    if (selectedColaborador) {
      computedComments = computedComments.filter((e) =>
        e.idColaboradores.includes(selectedColaborador)
      );
    }

    if (selectedFechaInicio) {
      computedComments = computedComments.filter(
        (e) => e.fecha >= selectedFechaInicio
      );
    }

    if (selectedFechaFin) {
      computedComments = computedComments.filter(
        (e) => e.fecha <= selectedFechaFin
      );
    }

    setTotalItems(computedComments.length);

    //Sorting comments
    if (
      sorting.field &&
      sorting.field != "total_cantidad" &&
      sorting.field != "numero"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (sorting.field == "total_cantidad" || sorting.field == "numero")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (sorting.field == "total_cantidad" || sorting.field == "numero")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    selectedCliente,
    selectedColaborador,
    selectedFechaInicio,
    selectedFechaFin,
  ]);

  // save
const cerrarPedido = async () => {
  const confirm = await Swal.fire({
    title: "¿Estas seguro?",
    text: "Se cerrará el pedido y sus artículos se desactivarán.",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Sí, cerrar",
  });

  if (!confirm.isConfirmed) return;

  // console.log("Pedido a cerrar:", selectedPedido);
  // console.log("URL pedido:", `${URL_PEDIDOS}/${selectedPedido}`);
  // console.log("URL artículos:", `${URL_ARTICULOS_PEDIDO}/baja/${selectedPedido}`);

  try {
    // PATCH al pedido
    const resPedido = await axios.patch(
      `${URL_PEDIDOS}/${selectedPedido}`,
      { status: "Cerrado" },
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }
    );
    // console.log("Resultado pedido cerrado:", resPedido.data);

    // PATCH a artículos del pedido
    const resArticulos = await axios.patch(
      `${URL_ARTICULOS_PEDIDO}/baja/${selectedPedido}`,
      { is_active: "No" },
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }
    );
    // console.log("Resultado artículos dados de baja:", resArticulos.data);

    Swal.fire({
      position: "center",
      icon: "success",
      title: "Se cerró el pedido",
      showConfirmButton: false,
      timer: 2000,
    });

    setTimeout(() => {
      // window.location.reload();
    }, 1000);
  } catch (error) {
    console.error("Error al cerrar pedido:", error);
    Swal.fire({
      icon: "error",
      title: "Error al cerrar",
      text: error.response?.data || error.message,
    });
  }
};




const saveSurtidos = async (event) => {
  event.preventDefault();
  setValidaBoton(false);
  toggleProgreso();

  let totalArticulos = inputFields.length;

  // Asegurar que los valores numéricos estén definidos y convertidos correctamente
  let fleteNum = parseFloat(comisionFlete) || 0;
  let comisionTDCNum = parseFloat(comisionTDC) || 0;
  let descuentoNum = parseFloat(descuento) || 0;
  let impuestosNum = parseFloat(impuestos) || 0;

  let iva = 0;
  let TT = 0;
  let DESC = 0;

  // El subtotal se saca de piezas × precio × descuento de cada renglón, no del
  // `total` que trae el renglón en pantalla: ese depende de por dónde se
  // capturó (piezas o cajas) y ya hubo un camino que se saltaba el descuento.
  let ST = inputFields.reduce(
    (t, c) =>
      t +
      (parseFloat(c.cantidad) || 0) *
        (parseFloat(c.precio) || 0) *
        (1 - (parseFloat(c.descuento) || 0) / 100),
    0
  );

  if (descuentoNum !== 0) {
    DESC = (ST * descuentoNum) / 100;
  }

  if (impuestosNum !== 0) {
    iva = (impuestosNum * (ST - DESC)) / 100;
  }

  TT = ST + iva + fleteNum + comisionTDCNum - DESC;

  // Cálculo seguro de total de cajas
  let totalCajas = inputFields.reduce((sum, a) => sum + (parseFloat(a.cajas) || 0), 0);

  // C6: heredar requiereFactura del cliente
  const clienteObj = (clientes || []).find((c) => c._id === cliente);
  const requiereFacturaCliente = clienteObj?.requiereFactura || "No";

  // Antes de crear NADA: ningún renglón que se vaya a surtir puede ir a precio
  // 0. El back lo rechaza renglón por renglón, pero para entonces la nota ya
  // existe y los renglones anteriores ya descontaron inventario; el pedido
  // 550 acumuló 9 notas a medias así en una mañana.
  const sinPrecio = inputFields.filter(
    (a) => Number(a.cantidad) > 0 && !(Number(a.precio) > 0)
  );
  if (sinPrecio.length) {
    setValidaBoton(true);
    Swal.fire({
      icon: "error",
      title: "Hay artículos con precio en $0",
      html:
        `No se puede surtir. Captura el precio en el pedido de:<br><br>` +
        `<b>${sinPrecio
          .map((a) => `${a.articuloCodigo || ""} ${a.articuloNombre || ""}`.trim())
          .join("</b><br><b>")}</b>`,
    });
    return;
  }

  // Si algo truena a medio camino, se cancela la nota recién creada: el
  // endpoint de cancelar regresa inventario y pendientes de lo que alcanzó a
  // guardarse, y la deja inactiva.
  let idNotaCreada = null;

  try {
    const { data } = await axios.post(
      URL_SURTIDOS,
      {
        fecha,
        pedidos: selectedPedido,
        observaciones,
        user: user.id,
        clientes: cliente,
        areas: selectedArea,
        total_general: parseFloat(TT).toFixed(2),
        saldo: parseFloat(TT).toFixed(2),
        subTotal: parseFloat(ST).toFixed(2),
        iva: parseFloat(iva).toFixed(2),
        impuestos: impuestosNum,
        is_active: "Si",
        colaboradores: selectedColaboradorSurtido,
        comisionPagada: "No",
        fotoEvidencia: "No",
        mail: "No",
        salidaBodega,
        plazo,
        comision,
        descuento: descuentoNum,
        total_cantidad: total,
        noGuia: "Sin Guia",
        noFactura: "Sin Factura",
        empresas: selectedEmpresa,
        flete: fleteNum,
        requiereFactura: requiereFacturaCliente,
        // U12/U13: sucursal entrega + paqueteria
        ...(selectedSucursal ? { sucursales: selectedSucursal } : {}),
        ...(selectedPaqueteria ? { paqueterias: selectedPaqueteria } : {}),
      },
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }
    );

    idNotaCreada = data?._id || null;

    // El PDF/WhatsApp va DESPUÉS de guardar los renglones (ver más abajo):
    // aquí la nota existe pero todavía no tiene artículos, y el documento
    // saldría incompleto o con datos que no corresponden.

    for (const a of inputFields) {
      if (a.cantidad > 0) {
        await axios.post(
          URL_ARTICULOS_SURTIDOS,
          {
            surtidos: data._id,
            inventarios: a.idInv,
            cantidad: parseFloat(a.cantidad),
            articulos: a.articulos,
            pedidos: selectedPedido,
            articulosPedido: a.idArtPed,
            areas: selectedArea,
            clientes: cliente,
            fecha,
            costoUnitario: a.costoUnitario,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );
      }
    }

    // Ya con todos los renglones guardados
    if (data.impuestos === 16 && alertasVentasCliente === "Si") {
      PDFOCWA(data.idSurtido, ST, iva, TT, totalCajas);
    }

    await axios.post(
      URL_LOGS,
      {
        tipo: "Crear Surtido",
        detalle: `${numero_pedido} ${selectedArea} ${total}`,
        user: user.id,
      },
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }
    );

    // Si se surtió TODO lo pendiente, cerrar sin preguntar.
    // Si aún queda pendiente, sí preguntar (por si el usuario decidió parar aquí).
    // El campo en inputFields se llama `pendSurtir` (ver mapping en jalaArticulos).
    const todoSurtido = inputFields.every((a) => {
      const pend = parseFloat(a.pendSurtir) || 0;
      const cant = parseFloat(a.cantidad) || 0;
      return pend - cant <= 0.005;
    });

    let cerrar = todoSurtido;
    if (!todoSurtido) {
      const result = await Swal.fire({
        title: "¿Deseas cerrar el pedido?",
        text: "Aún queda pendiente por surtir. Una vez cerrado, no se podrán hacer más surtidos.",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sí, cerrar pedido",
        cancelButtonText: "No",
      });
      cerrar = result.isConfirmed;
    }

    if (cerrar) {
      try {
        await axios.patch(
          `${URL_PEDIDOS}/${selectedPedido}`,
          { status: "Cerrado" },
          { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
        );
        await axios.patch(
          `${URL_ARTICULOS_PEDIDO}/baja/${selectedPedido}`,
          { is_active: "No" },
          { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
        );
      } catch (e) {
        console.error("Cerrar pedido:", e);
      }
      Swal.fire("¡Listo!", "Surtido creado y pedido cerrado", "success");
    } else {
      Swal.fire("¡Listo!", "Surtido creado", "success");
    }

    // D1: ofrecer mandar la nota por correo al cliente
    await ofrecerMailNota(data, clienteObj, { subTotal: ST, iva, total: TT });

    setTimeout(() => window.location.reload(), 1000);
  } catch (error) {
    console.error(error);
    const msg =
      error?.response?.data?.message ||
      error?.response?.data?.validation?.body?.message ||
      error?.message ||
      "Error inesperado";

    // Deshacer lo que alcanzó a guardarse para no dejar la nota a medias
    let deshecho = false;
    if (idNotaCreada) {
      try {
        await axios.patch(
          `${URL_SURTIDOS}DeshacerReciente/${idNotaCreada}`,
          {},
          { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
        );
        deshecho = true;
      } catch (e2) {
        console.error("No se pudo deshacer la nota a medias:", e2);
      }
    }

    Swal.fire({
      icon: "error",
      title: "No se pudo surtir",
      html:
        `${msg}` +
        (idNotaCreada
          ? deshecho
            ? `<br><br><small>La nota que se había empezado a crear se canceló sola: inventario y pendientes quedaron como estaban.</small>`
            : `<br><br><small style="color:#b02307">Se creó una nota a medias y no se pudo cancelar automáticamente. Cancélala desde Ventas antes de volver a intentar.</small>`
          : ""),
    });
    setValidaBoton(true);
  }
};



  const handleAddFields = () => {
    setInputFields([
      ...inputFields,
      {
        id: uuidv4(),
        articulos: "",
        cantidad: 0,
        cantInv: 0,
        idInv: "",
        idArtPed: "",
        cajas: 0,
        piezasPorCaja: 0,
        precio: 0,
        total: 0,
        pendSurtir: 0,
        cantPed: 0,
        costoUnitario:0
      },
    ]);
  };

  const handleRemoveFields = (id) => {
    const values = [...inputFields];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFields(values);
    let cant = values.map((c) => parseFloat(c.cantidad));
    let TC = cant.reduce((t, total, index) => t + total, 0);
    setTotal(TC);
  };

  const handleChangeInputCantidad = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        // if(i.cantInv >= event.target.value ){
        if (
          (i.cantInv >= event.target.value 
            // &&
            // i.pendSurtir >= event.target.value
            ) 
            ||
          event.target.value == ""
        ) {
          i[event.target.name] = event.target.value;
          i.cajas = (parseFloat(event.target.value) / parseFloat(i.piezasPorCaja)).toFixed(2);
          const desc = parseFloat(i.descuento) || 0;
          i.total = parseFloat(event.target.value) * parseFloat(i.precio) * (1 - desc / 100);
        }else{
          i.cantidad = 0
            i.cajas = 0
            i.total = 0
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "La cantidad excede el inventario!",
          });
        }
        // } else {
        //   Swal.fire({
        //     icon: "error",
        //     title: "Oops...",
        //     text: "La cantidad excede tu inventario!",
        //     showConfirmButton: false,
        //   });
        //   i.cajas = 0;
        //   i.cantidad = 0;
        // }
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };
// console.log("hola", inputFields)
  const handleChangeInputCantidadCajas = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        // if(i.cantInv >= (event.target.value * i.piezasPorCaja) ){
        let cantTemp =
          parseFloat(event.target.value) * parseFloat(i.piezasPorCaja);
        if (
          (i.cantInv >= cantTemp 
            // && i.pendSurtir >= cantTemp
          ) ||
          event.target.value == ""
        ) {
          i[event.target.name] = event.target.value;
          i.cantidad =
            parseFloat(event.target.value) * parseFloat(i.piezasPorCaja);
          // Con el descuento del renglón, igual que al capturar por piezas.
          // Sin él, la nota 585 (oct-2026) se guardó $10,680.60 arriba.
          const desc = parseFloat(i.descuento) || 0;
          i.total =
            parseFloat(event.target.value) *
            parseFloat(i.piezasPorCaja) *
            parseFloat(i.precio) *
            (1 - desc / 100);
          }else{
            i.cantidad = 0
              i.cajas = 0
              i.total = 0
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "La cantidad excede el inventario!",
            });
          }
        // } else {
        //   Swal.fire({
        //     icon: "error",
        //     title: "Oops...",
        //     text: "La cantidad excede tu pedido!",
        //     showConfirmButton: false,
        //   });
        //   i.cajas = 0;
        //   i.cantidad = 0;
        // }
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  function BuscaArticulo(id, event) {
    if (
      inventarios.filter((e) => e.idArticulo == event.target.value).length == 1
    ) {
      let artPed = articulosPed
        .map((a) => {
          if (a.articulos == event.target.value) {
            return a.idArtPed;
          }
        })
        .filter(function (el) {
          return el != null;
        });

      let pendSurtir = articulosPed
        .map((a) => {
          if (a.articulos == event.target.value) {
            return a.pendSurtir;
          }
        })
        .filter(function (el) {
          return el != null;
        });

      let precio = articulosPed
        .map((a) => {
          if (a.articulos == event.target.value) {
            return a.precio;
          }
        })
        .filter(function (el) {
          return el != null;
        });

      inventarios.map((a) => {
        if (a.idArticulo == event.target.value) {
          let idArticulo = a.idArticulo;
          let cantInv = parseFloat(a.cantidad);
          let idInv = a._id;
          let piezasPorCaja = a.piezasPorCaja;
          let costoUnitario = a.costoUnitario
          handleChangeInputArticuloUnico(
            id,
            idArticulo,
            piezasPorCaja,
            cantInv,
            idInv,
            artPed,
            precio,
            pendSurtir,
            costoUnitario
          );
        }
      });
    } else {
      let artPed = articulosPed
        .map((a) => {
          if (a.articulos == event.target.value) {
            return a.idArtPed;
          }
        })
        .filter(function (el) {
          return el != null;
        });

      let pendSurtir = articulosPed
        .map((a) => {
          if (a.articulos == event.target.value) {
            return a.pendSurtir;
          }
        })
        .filter(function (el) {
          return el != null;
        });

      let precio = articulosPed
        .map((a) => {
          if (a.articulos == event.target.value) {
            return a.precio;
          }
        })
        .filter(function (el) {
          return el != null;
        });

      inventarios.map((a) => {
        if (a.idArticulo == event.target.value) {
          let idArticulo = a.idArticulo;
          let piezasPorCaja = a.piezasPorCaja;
          let costoUnitario = a.costoUnitario
          handleChangeInputArticulo(
            id,
            idArticulo,
            piezasPorCaja,
            artPed,
            precio,
            pendSurtir,
            costoUnitario
          );
        }
      });
    }
  }
  const handleChangeInputArticuloUnico = (
    id,
    idArticulo,
    piezasPorCaja,
    cantInv,
    idInv,
    artPed,
    precio,
    pendSurtir,
    costoUnitario
  ) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.articulos = idArticulo;
        i.cantInv = parseFloat(cantInv);
        i.idInv = idInv;
        i.idArtPed = artPed[0];
        i.piezasPorCaja = parseFloat(piezasPorCaja);
        i.precio = parseFloat(precio);
        i.pendSurtir = parseFloat(pendSurtir);
        i.costoUnitario = costoUnitario
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  const handleChangeInputArticulo = (
    id,
    idArticulo,
    piezasPorCaja,
    artPed,
    precio,
    pendSurtir
  ) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.articulos = idArticulo;
        i.idArtPed = artPed[0];
        i.piezasPorCaja = parseFloat(piezasPorCaja);
        i.precio = parseFloat(precio);
        i.pendSurtir = parseFloat(pendSurtir);
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };



  function ActualizaTotales() {
    let cant = inputFields.map((c) => parseFloat(c.cantidad));
    let TC = cant.reduce((t, total, index) => t + total, 0);
    setTotal(TC);

    let cantCajas = inputFields.map((c) => parseFloat(c.cajas));
    let TTC = cantCajas.reduce((t, total, index) => t + total, 0);
    setTotalCajas((TTC).toFixed(2));
  }

  function BuscaCodigo(id, event) {
    if (event.target.value.length >= 24) {
      if (idsArticulos.includes(event.target.value)) {
        let artPed = articulosPed
          .map((a) => {
            if (a.articulos == event.target.value) {
              return a.idArtPed;
            }
          })
          .filter(function (el) {
            return el != null;
          });

        let precio = articulosPed
          .map((a) => {
            if (a.articulos == event.target.value) {
              return a.precio;
            }
          })
          .filter(function (el) {
            return el != null;
          });

        inventarios.map((a) => {
          if (a.idArticulo == event.target.value) {
            let idArticulo = a.idArticulo;
            let piezasPorCaja = a.piezasPorCaja;
            let costoUnitario = a.costoUnitario
            handleChangeInputArticulo(
              id,
              idArticulo,
              piezasPorCaja,
              artPed,
              precio,
              costoUnitario
            );
          }
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "El modelo no aparece en tu pedido",
          showConfirmButton: false,
        });
        const newInputFields = inputFields.map((i) => {
          if (id === i.id) {
            i.articulos = "";
          }
          return i;
        });
        setInputFields(newInputFields);
      }
    } else {
      const newInputFields = inputFields.map((i) => {
        if (id === i.id) {
          i.articulos = event.target.value;
        }
        return i;
      });
      setInputFields(newInputFields);
    }
  }

  async function seleccionarPedido(
    id,
    numero,
    idClientes,
    clientes,
    codigo,
    impuestos,
    comisionFlete,
    comisionTDC,
    descuento,
    idColaboradores,
    alertasVentas,
    telefono,
    vendedor,
    calle,
    numero_ext,
    numero_int,
    estado,
    ciudad,
    delegacion,
    colonia,
    cp,
    paqueteria,
    RFC,
  ) {
    setSelectedPedido(id);
    setNumeroPedido(numero);
    setCliente(idClientes);
    setImpuestos(impuestos);
    setComisionTDC(comisionTDC);
    setClientesName(clientes);
    setClientesCodigo(codigo);
    setDescuento(descuento)
    setAlertasVentasCliente(alertasVentas);
    setSelectedClienteTelefono(telefono);
    setVendedor(vendedor);
    setArea(area);
    setCalle(calle);
    setNumero_ext(numero_ext);
    setNumero_int(numero_int);
    setEstado(estado);
    setCiudad(ciudad);
    setDelegacion(delegacion);
    setColonia(colonia);
    setCp(cp);
    setPaqueteria(paqueteria);
    setRFC(RFC);
    setSelectedColaboradorSurtido(idColaboradores);
    setFlete(comisionFlete)

    // Cargar sucursales y paqueterías
    setSelectedSucursal("");
    setSelectedPaqueteria("");
    if (URL_SUCURSALES) {
      axios.get(URL_SUCURSALES, { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } })
        .then((res) => {
          const sucs = (res.data || []).filter((s) => {
            const cid = (s.clientes?.[0]?._id || s.clientes?.[0] || "").toString();
            return cid === idClientes && s.is_active !== "No";
          });
          setSucursalesCliente(sucs);
          // Si solo hay una sucursal, seleccionarla automáticamente
          if (sucs.length === 1) setSelectedSucursal(sucs[0]._id);
        })
        .catch(() => setSucursalesCliente([]));
    }
    if (URL_PAQUETERIAS) {
      axios.get(URL_PAQUETERIAS, { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } })
        .then((res) => setPaqueterias(res.data || []))
        .catch(() => setPaqueterias([]));
    }

    toggleAreaSurtir()
  }

  function jalaArticulos(){
    setInputFields([
      {
        id: uuidv4(),
        articulos: "",
        cantidad: 0,
        cantInv: 0,
        idInv: "",
        idArtPed: "",
        cajas: 0,
        piezasPorCaja: 0,
        precio: 0,
        total: 0,
        pendSurtir: 0,
        cantPed: 0,
        costoUnitario:0
      },
    ])
    axios
    .get(`${URL_ARTICULOS_PEDIDO}/surtir3/${selectedPedido}/${selectedArea}`, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((res) => {
      const allArticulosPed = res.data;
      setArticulosPed(allArticulosPed);

      let arrayInputFields = allArticulosPed
        .map((a) => {
          const cantDef = Math.max(0, Math.min(parseFloat(a.pendSurtir) || 0, parseFloat(a.cantInv) || 0));
          const cajasDef = a.piezasPorCaja ? Math.round((cantDef / parseFloat(a.piezasPorCaja)) * 100) / 100 : 0;
          const desc = parseFloat(a.descuento) || 0;
          return {
            id: uuidv4(),
            articulos: a.articulos,
            cantidad: cantDef,
            cantInv: a.cantInv,
            idInv: a.idInv,
            idArtPed: a.idArtPed,
            cajas: cajasDef,
            piezasPorCaja: a.piezasPorCaja,
            precio: a.precio,
            descuento: desc,
            total: cantDef * parseFloat(a.precio || 0) * (1 - desc / 100),
            pendSurtir: a.pendSurtir,
            articuloNombre: a.articuloNombre,
            articuloCodigo: a.articuloCodigo,
            cantPed: a.cantPed,
            costoUnitario: a.costoUnitario
          };
        })
        .sort((a, b) => (a.articuloNombre > b.articuloNombre ? 1 : -1));

      let dataIF = Object.values(arrayInputFields);

      setInputFields(dataIF);

      // V15: recalcular totales con los valores default ya cargados
      const TC = dataIF.reduce((acc, c) => acc + (parseFloat(c.cantidad) || 0), 0);
      const TTC = dataIF.reduce((acc, c) => acc + (parseFloat(c.cajas) || 0), 0);
      setTotal(TC);
      setTotalCajas(TTC.toFixed(2));

      let result = allArticulosPed.map((a) => a.articulos);
      setIdsArticulos(result);

      avisaSinPrecio(dataIF);

    })
    .catch((err) => {
      console.log(err);
    });
    setModalAreaSurtir(false);
  setAbrirSurtir(true);
  }

  // Al abrir el surtido: si el pedido trae renglones en $0 se dice de una vez
  // cuáles son, en lugar de dejar que lo descubran al guardar la nota.
  function avisaSinPrecio(lineas) {
    const malos = (lineas || []).filter(
      (a) => Number(a.pendSurtir) > 0 && !(Number(a.precio) > 0)
    );
    if (!malos.length) return;
    Swal.fire({
      icon: "warning",
      title: "Este pedido tiene artículos en $0",
      html:
        `No se podrá surtir hasta que se capture el precio en el pedido:<br><br>` +
        `<b>${malos
          .map((a) => `${a.articuloCodigo || ""} ${a.articuloNombre || ""}`.trim())
          .join("</b><br><b>")}</b>` +
        `<br><br>Puedes surtir el resto dejando esos renglones en cantidad 0.`,
    });
  }

function PDFOCWA(idSurtido, subTotal, iva, total){


  const data = inputFields.map((a) => {
    return [
      a.articuloNombre,
      new Intl.NumberFormat("en-US",{maximumFractionDigits: 2}).format(a.cajas),
      new Intl.NumberFormat("en-US").format(a.cantidad),
      new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: 2,
        
      }).format(a.precio),
      new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: 2,
        
      }).format(a.total),
    ];
  });

  const dataPDF = Object.values(data);
  const dataPDFLimpia = dataPDF.filter(function (el) {
    return el != null;
  });
  const doc = new jsPDF({compressPdf: true});
  var img = new Image();
  var img2 = new Image();
  img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
  doc.addImage(img2, "png", 10, 11, 20, 5);

  doc.setFontSize(12);
  doc.text(`Fecha:`, 35, 15);
  doc.text(`${fecha}`, 60, 15);
  doc.text(`Nota:`, 35, 20);
  doc.text(`${idSurtido}`, 60, 20);
  doc.text(`Pedido:`, 35, 25);
  doc.text(`${numero_pedido}`, 60, 25);

  doc.text(`Ejecutivo:`, 120, 15);
  doc.text(`${vendedor}`, 150, 15);

  doc.setFontSize(8);
  doc.text(`Cliente: ${clientesName}`, 10, 32);
  doc.text(`RFC: ${RFC}`, 150, 32);
  doc.text(
    `Direccion de Envio: ${calle} #${numero_ext} Int. ${numero_int} Telefono: ${selectedClienteTelefono}`,
    10,
    42
  );
  doc.text(
    `Edo: ${estado}, Ciudad: ${ciudad}, Del: ${delegacion}, Col: ${colonia}, CP: ${cp} Paqueteria: ${paqueteria}`,
    10,
    47
  );

  doc.autoTable({
    head: [["Articulo", "Cajas", "Cantidad", "Precio", "Total"]],
    body: dataPDFLimpia,
 headStyles: {
            fillColor: ["#B02307"],
            lineWidth: 0
          },
          footStyles: {
            fillColor: ["#B02307"],
          },
          theme:"grid",
    styles: {
      fontSize: 8,
      overflow: "linebreak",
      columnWidth: "wrap",
      // font: 'arial',
      overflowColumns: "linebreak",
    },
    margin: { left: 5, right: 5 },
    startY: 50,
    foot: [
      [
        "",
        new Intl.NumberFormat("en-US").format(totalCajas) + " Cajas",
        new Intl.NumberFormat("en-US").format(total) + " Piezas",
        "Sub Total",
        new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
          maximumFractionDigits: 2,
          
        }).format(subTotal),
      ],
      [
        "",
        "",
        "",
        `Comision`,
        new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
          maximumFractionDigits: 2,
          
        }).format(iva),
      ],
      [
        "",
        "",
        "",
        "Comision TDC",
        new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
          maximumFractionDigits: 2,
          
        }).format(comisionTDC),
      ],
      [
        "",
        "",
        "",
        "Comision Flete",
        new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
          maximumFractionDigits: 2,
          
        }).format(flete),
      ],
      [
        "",
        "",
        "",
        "Total",
        new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
          maximumFractionDigits: 2,
          
        }).format(total),
      ],
    ],
    showFoot: "lastPage",
  });

  var att = doc.output("arraybuffer");

  let params = new URLSearchParams( {
    number: selectedClienteTelefono,
      message:`Hola ${clientesName}, Estamos preparando tu pedido. Gracias por confiar en ${process.env.REACT_APP_NOMBRE_INSTITUCION}, estamos para servirte!`,
      fileName:`Nota-${idSurtido}.pdf`,
    mimetype: "application/pdf",
  })

  axios
    .post(
      `${URL_WHATSAPP}SendPDFFront?${params.toString()}`,
      att,
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem(
            "app_token"
          )}`,
          "Content-Type": "application/octet-stream",
        },
      }
    )
}
  // ── Aviso de pedidos nuevos.
  // Almacén deja esta pantalla abierta; sin esto sólo se entera de un pedido
  // recién autorizado si recarga a mano. Cada 45 s se consulta el mismo
  // endpoint con el mismo filtro y, si aparece un pedido que no está en la
  // tabla, se muestra el aviso. No se recarga solo: podrían estar a media
  // captura de un surtido.
  const [pedidosNuevos, setPedidosNuevos] = useState([]);
  // Pedidos con renglones pendientes en precio $0: el surtido los rechaza, así
  // que se avisa desde el listado y no hasta que almacén intenta guardar.
  const [sinPrecio, setSinPrecio] = useState([]);
  useEffect(() => {
    const idsCargados = new Set((comments || []).map((c) => String(c._id)));
    let vivo = true;
    const revisar = async () => {
      try {
        const res = await axios.get(`${URL_PEDIDOS}PendienteSurtir`, {
          headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
        });
        if (!vivo) return;
        const nuevos = (res.data || [])
          .filter(
            (p) =>
              p.is_active === "Si" &&
              (p.status || "Abierto") === "Abierto" &&
              p.autorizadoSurtido === "Si" &&
              p.surtido !== "Si" &&
              !idsCargados.has(String(p._id))
          )
          .map((p) => ({
            _id: p._id,
            numero: p.idPedido,
            cliente: p.clientes?.[0]?.nombre_comercial || "",
          }));
        setPedidosNuevos(nuevos);
      } catch (e) {
        // Si falla el sondeo no se molesta al usuario: se reintenta al siguiente.
      }
    };
    const timer = setInterval(revisar, 45000);
    return () => {
      vivo = false;
      clearInterval(timer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [comments]);

  useEffect(() => {
    let vivo = true;
    axios
      .get(`${URL_ARTICULOS_PEDIDO}SinPrecio`, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then((res) => {
        if (vivo) setSinPrecio(res.data || []);
      })
      .catch((err) => console.log("[sinPrecio]", err));
    return () => {
      vivo = false;
    };
  }, [URL_ARTICULOS_PEDIDO]);

  // Renglones en $0 de un pedido (undefined si no tiene)
  const sinPrecioDe = (idPedido) =>
    sinPrecio.find((x) => String(x.pedido) === String(idPedido));

  const money = (n) =>
    new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 2,
    }).format(Number(n) || 0);

  return (
    <>
      <Header />
      <br />
      <br />
      {user.surtidos_create ? (
        <div className="card col-12">
          {pedidosNuevos.length > 0 ? (
            <div
              role="alert"
              style={{
                position: "sticky",
                top: 0,
                zIndex: 5,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 12,
                margin: "8px 0",
                padding: "10px 14px",
                background: "#fff3cd",
                border: "1px solid #ffe69c",
                borderLeft: "5px solid #ffc107",
                borderRadius: 4,
                fontSize: 14,
              }}
            >
              <span>
                <i className="fas fa-bell"></i>{" "}
                {pedidosNuevos.length === 1
                  ? <>Entró un pedido nuevo: <b>#{pedidosNuevos[0].numero}</b> · {pedidosNuevos[0].cliente}</>
                  : <>Entraron <b>{pedidosNuevos.length}</b> pedidos nuevos: {pedidosNuevos.map((p) => `#${p.numero}`).join(", ")}</>}
              </span>
              <Button size="sm" color="warning" onClick={() => window.location.reload()}>
                <i className="fas fa-sync-alt"></i> Actualizar
              </Button>
            </div>
          ) : null}
          {sinPrecio.length > 0 ? (
            <div
              role="alert"
              style={{
                margin: "8px 0",
                padding: "10px 14px",
                background: "#f8d7da",
                border: "1px solid #f5c2c7",
                borderLeft: "5px solid #dc3545",
                borderRadius: 4,
                fontSize: 14,
              }}
            >
              <b>
                <i className="fas fa-exclamation-triangle"></i> No se pueden surtir{" "}
                {sinPrecio.length === 1 ? "1 pedido" : `${sinPrecio.length} pedidos`}: tienen
                artículos con precio en $0
              </b>
              <br />
              Hay que capturar el precio en el pedido (Ventas → Pedidos → editar):
              <ul style={{ marginBottom: 0, marginTop: 4 }}>
                {sinPrecio.map((p) => (
                  <li key={p.pedido}>
                    <b>#{p.idPedido}</b> {p.cliente} —{" "}
                    {p.articulos
                      .map(
                        (a) =>
                          `${a.codigo} (${a.pendiente} pzas${
                            a.sugerido > 0
                              ? `, lista ${p.listaPrecios} = ${money(a.sugerido)}`
                              : ", sin precio de lista"
                          })`
                      )
                      .join(", ")}
                  </li>
                ))}
              </ul>
            </div>
          ) : null}
          {!abrirSurtir ? (
            <div>
              <Row>
                <Col md={8}>
                  <Button
                    size="sm"
                    href="/MenuVentas"
                    className="btn btn-danger"
                    id="botonListado"
                  >
                    Regresar
                  </Button>
                </Col>
                <Col sm={4}>
                  <ButtonGroup id="logoutBoton">
                    <Button
                      size="sm"
                      className="btn"
                      color="danger"
                      onClick={PDFTabla}
                    >
                      PDF <i class="far fa-file-pdf"></i>
                    </Button>
                    <Button
                      size="sm"
                      className="btn"
                      onClick={toggleMail}
                      color="info"
                    >
                      eMail <i class="fas fa-at"></i>
                    </Button>
                    <Button
                      size="sm"
                      className="btn"
                      color="primary"
                      onClick={excel}
                    >
                      Excel <i class="far fa-file-excel"></i>
                    </Button>
                  </ButtonGroup>
                </Col>
              </Row>
              {/* Visor del pedido en tabla: misma información que el PDF, sin generarlo */}
      <Modal size="lg" isOpen={!!pedidoPreview} toggle={cerrarPedidoPreview}>
        <ModalHeader toggle={cerrarPedidoPreview}>
          <h4>Pedido # {pedidoPreview?.numero}</h4>
        </ModalHeader>
        <ModalBody>
          {pedidoPreview ? (
            <>
              <Row className="mb-2" style={{ fontSize: 14 }}>
                <Col md={6}>
                  <b>Fecha:</b> {fDMA(pedidoPreview.fecha)}
                  <br />
                  <b>Cliente:</b>{" "}
                  {pedidoPreview.codigoClientes ? `${pedidoPreview.codigoClientes} - ` : ""}
                  {pedidoPreview.clientes}
                  <br />
                  <b>Vendedor:</b> {pedidoPreview.colaboradores}
                </Col>
                <Col md={6}>
                  {pedidoPreview.paqueteria ? (
                    <>
                      <b>Paquetería:</b> {pedidoPreview.paqueteria}
                      <br />
                    </>
                  ) : null}
                  <b>Observaciones:</b> {pedidoPreview.observaciones || "NA"}
                </Col>
              </Row>
              <Table size="sm" bordered className="table-responsive-xl">
                <thead>
                  <tr align="center">
                    <th className="tituloTabla" style={{ textAlign: "left" }}>Artículo</th>
                    <th className="tituloTabla">Cantidad</th>
                    <th className="tituloTabla">Cajas</th>
                    <th className="tituloTabla">Surtido</th>
                    <th className="tituloTabla">Pend. Surtir</th>
                  </tr>
                </thead>
                <tbody>
                  {pedidoPreview.filas.map((f, i) => (
                    <tr
                      key={i}
                      // Mismo amarillo que el PDF para los renglones editados
                      style={f.editado === "Si" ? { backgroundColor: "#ffe680" } : undefined}
                    >
                      <td>{f.articulos}</td>
                      <td align="right">{new Intl.NumberFormat("en-US").format(f.cantidad)}</td>
                      <td align="right">
                        {new Intl.NumberFormat("en-US", { maximumFractionDigits: 2 }).format(f.cajas)}
                      </td>
                      <td align="right">{new Intl.NumberFormat("en-US").format(f.surtido)}</td>
                      <td align="right">{new Intl.NumberFormat("en-US").format(f.pendiente_surtir)}</td>
                    </tr>
                  ))}
                  <tr>
                    <td className="negrita">Total</td>
                    <td className="negrita" align="right">
                      {new Intl.NumberFormat("en-US").format(pedidoPreview.totalPzas)} piezas
                    </td>
                    <td className="negrita" align="right">
                      {new Intl.NumberFormat("en-US", { maximumFractionDigits: 2 }).format(pedidoPreview.totalCajas)} cajas
                    </td>
                    <td></td>
                    <td></td>
                  </tr>
                </tbody>
              </Table>
            </>
          ) : null}
        </ModalBody>
        <ModalFooter>
          <Button size="sm" color="secondary" onClick={cerrarPedidoPreview}>
            Cerrar
          </Button>
        </ModalFooter>
      </Modal>

      <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
                <ModalHeader toggle={toggleMail}>
                  <h4>Enviar Listado Pendiente Surtir</h4>
                </ModalHeader>
                <ModalBody>
                  <Label className="mr-sm-2">Email</Label>
                  <Input
                    className="col-sm-12"
                    type="text"
                    value={mailTo}
                    required
                    onChange={(e) => {
                      setMailTo(e.target.value);
                    }}
                  />
                </ModalBody>
                <ModalFooter>
                  <Button size="sm" color="success" onClick={enviaMail}>
                    Enviar
                  </Button>
                </ModalFooter>
              </Modal>
              <h3 align="center">Pendientes de Surtir</h3>
              <div className="row">
                <div className="col-md-8">
                  <Pagination
                    total={totalItems}
                    itemsPerPage={ITEMS_PER_PAGE}
                    currentPage={currentPage}
                    onPageChange={(page) => setCurrentPage(page)}
                  />
                </div>
                <div className="col-md-4 d-flex flex-row-reverse">
                  <Search
                    onSearch={(value) => {
                      setSearch(value);
                      setCurrentPage(1);
                    }}
                  />
                </div>
              </div>

              <Row>
                <Col md={2}>
                  <Label className="mr-sm-2">Fecha Inicio</Label>
                  <Input
                    bsSize="sm"
                    type="date"
                    value={selectedFechaInicio}
                    required
                    onChange={(e) => {
                      setSelectedFechaInicio(e.target.value);
                    }}
                  />
                </Col>
                <Col md={2}>
                  <Label className="mr-sm-2">Fecha Fin</Label>
                  <Input
                    bsSize="sm"
                    type="date"
                    value={selectedFechaFin}
                    required
                    onChange={(e) => {
                      setSelectedFechaFin(e.target.value);
                    }}
                  />
                </Col>
                <Col md={2}>
                  <Label>Clientes</Label>
                  <Input
                    bsSize="sm"
                    type="select"
                    value={selectedCliente}
                    onChange={(e) => {
                      setSelectedCliente(e.target.value);
                      setCurrentPage(1);
                    }}
                  >
                    <option value="0">Selecciona</option>
                    {clientes
                      .sort((a, b) =>
                        a.nombre_comercial > b.nombre_comercial ? 1 : -1
                      )
                      .map((a) => {
                        return (
                          <option value={a._id}>{a.nombre_comercial}</option>
                        );
                      })}
                  </Input>
                </Col>

                <Col md={2}>
                  <Label>Vendedor</Label>
                  <Input
                    bsSize="sm"
                    type="select"
                    value={selectedColaborador}
                    onChange={(e) => {
                      setSelectedColaborador(e.target.value);
                      setCurrentPage(1);
                    }}
                  >
                    <option value="">Selecciona un Vendedor</option>
                    {colaboradores
                      .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                      .map((a) => {
                        return (
                          <option value={a._id}>
                            {a.nombre} {a.apellido}
                          </option>
                        );
                      })}
                  </Input>
                </Col>
              </Row>
              <br />
              <Table
                size="sm"
                striped
                borderless
                className="table-responsive-xl"
              >
                <TableHeader
                  headers={headers}
                  onSorting={(field, order) => setSorting({ field, order })}
                />
                <tbody>
                  {commentsData.map((a) => {
                    // Colores del renglón (ambos se quitan al sacar el PDFOC):
                    //   azul     = autorizado y almacén todavía no lo imprime
                    //   amarillo = se editó DESPUÉS de autorizado (gana al azul:
                    //              si cambió, hay que verlo aunque no se haya impreso)
                    const sinImprimir = a.pdfImpreso !== "Si";
                    const editadoTrasAutorizar = a.editado == "Si";
                    if (sinImprimir || editadoTrasAutorizar) {
                      const bg = editadoTrasAutorizar
                        ? a.tipoEdicion === "articulos"
                          ? "orange"
                          : "#fff59d"
                        : "#bbdefb";
                      return (
                        <tr style={{ backgroundColor: bg }}>
                          <td>{celdaNumero(a)}</td>
                          <td>{celdaConfirmado(a)}</td>
                          <td>{a.clientes}</td>
                          <td>{a.estadoSucursal}</td>
                          <td>{a.colaboradores}</td>
                          <td>{fDMA(a.fecha_programada)}</td>
                          <td>
                            {a.paqueteria}{" "}
                            <Button
                              size="sm"
                              color="link"
                              style={{ padding: 0 }}
                              title="Editar paqueteria/fecha programada"
                              onClick={() => {
                                setEditInfoPedidoId(a._id);
                                setEditInfoPaqueteria(a.paqueteria || "");
                                setEditInfoFechaProg(a.fecha_programada || "");
                                // Cargar el catálogo de paqueterías para el select
                                if (URL_PAQUETERIAS) {
                                  axios
                                    .get(URL_PAQUETERIAS, {
                                      headers: {
                                        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                                      },
                                    })
                                    .then((res) => setPaqueterias(res.data || []))
                                    .catch(() => setPaqueterias([]));
                                }
                                setModalEditInfo(true);
                              }}
                            >
                              <i className="far fa-edit"></i>
                            </Button>
                          </td>
                          <td>
                              <div>
                                <Button
                                  size="sm"
                                  className="btn"
                                  color="danger"
                                  onClick={(e) =>
                                    PDFOC(
                                      a.fecha,
                                        a.colaboradores,
                                        a.idClientes,
                                        a.clientes,
                                        a.total_cantidad,
                                        a.total_general,
                                        a.observaciones,
                                        a.numero,
                                        a.impuestos,
                                        a.comisionFlete,
                                        a.comisionTDC,
                                        a._id,
                                        a.calle,
                                        a.numero_ext,
                                        a.numero_int,
                                        a.pais,
                                        a.estado,
                                        a.ciudad,
                                        a.delegacion,
                                        a.colonia,
                                        a.cp,
                                        a.RFC,
                                        a.paqueteria,
                                        a.codigoClientes,
                                        a.autorizadoApartado,
                                        a.autorizadoSurtido,
                                        a.telefono,
                                        a.editado,
                                        a.editPedido,
                                        a.autorizoApartado,
                                        a.autorizoSurtido
                                    )
                                  }
                                >
                                  <i class="far fa-file-pdf"></i>
                                </Button>

                                {/* Ver el pedido en un modal sin descargarlo */}
                                <Button
                                  size="sm"
                                  className="btn"
                                  color="info"
                                  title="Ver pedido"
                                  onClick={() => PDFOC(...argsPDFOC(a), true)}
                                >
                                  <i class="far fa-eye"></i>
                                </Button>

                                {/* PDF de peso de lo pendiente por surtir */}
                                <Button
                                  size="sm"
                                  className="btn"
                                  color="warning"
                                  title="PDF de Peso"
                                  onClick={() =>
                                    PDFPeso(a._id, a.numero, a.clientes, a.fecha, a.estado)
                                  }
                                >
                                  <i class="fas fa-weight-hanging"></i>
                                </Button>

                                <Button
                                  size="sm"
                                  className="btn"
                                  color="primary"
                                  onClick={(e) =>
                                    excelOC(
                                      a._id,
                                      a.clientes,
                                    )
                                  }
                                >
                                  <i class="far fa-file-excel"></i>
                                </Button>

                                {/* Regresar a azul: vuelve a quedar pendiente de imprimir */}
                                {(a.pdfImpreso === "Si" || a.editado === "Si") && (
                                  <>
                                    <Button
                                      size="sm"
                                      className="btn"
                                      outline
                                      color="info"
                                      id={`azul-${a._id}`}
                                      style={{ backgroundColor: "#fff" }}
                                      onClick={() => regresarAAzul(a)}
                                    >
                                      <i class="fas fa-fill-drip"></i>
                                    </Button>
                                    <UncontrolledTooltip placement="top" target={`azul-${a._id}`}>
                                      Regresar a azul (pendiente de imprimir)
                                    </UncontrolledTooltip>
                                  </>
                                )}

                              </div>
                          </td>
                          <td>
                          {a.surtido == "No" ? (
                            <Button
                              color="info"
                              id="Editar"
                              size="sm"
                              onClick={(e) =>
                                seleccionarPedido(
                                  a._id,
                                  a.numero,
                                  a.idClientes,
                                  a.clientes,
                                  a.codigo,
                                  a.impuestos,
                                  a.comisionFlete,
                                  a.comisionTDC,
                                  a.descuento,
                                  a.idColaboradores,
                                  a.alertasVentas,
                                  a.telefono,
                                  a.colaboradores,
                                  a.calle,
                                  a.numero_ext,
                                  a.numero_int,
                                  a.estado,
                                  a.ciudad,
                                  a.delegacion,
                                  a.colonia,
                                  a.cp,
                                  a.paqueteria,
                                  a.RFC,
                                )
                              }
                            >
                              <i class="fas fa-shipping-fast"></i>
                            </Button>
                          ):undefined}
                            
                          </td>
                          <td>
                            <StatusMultipleSurtido
                              idStatus={a._id}
                              status={a.surtido}
                              URL_STATUS={URL_PEDIDOS}
                              hijo={`${URL_ARTICULOS_PEDIDO}/baja`}
                            />
                            {"  "}Modificado
                          </td>
                        </tr>
                      );
                    } else {
                      return (
                        <tr>
                          <td>{celdaNumero(a)}</td>
                          <td>{celdaConfirmado(a)}</td>
                          <td>{a.clientes}</td>
                          <td>{a.estadoSucursal}</td>
                          <td>{a.colaboradores}</td>
                          <td>{fDMA(a.fecha_programada)}</td>
                          <td>
                            {a.paqueteria}{" "}
                            <Button
                              size="sm"
                              color="link"
                              style={{ padding: 0 }}
                              title="Editar paqueteria/fecha programada"
                              onClick={() => {
                                setEditInfoPedidoId(a._id);
                                setEditInfoPaqueteria(a.paqueteria || "");
                                setEditInfoFechaProg(a.fecha_programada || "");
                                // Cargar el catálogo de paqueterías para el select
                                if (URL_PAQUETERIAS) {
                                  axios
                                    .get(URL_PAQUETERIAS, {
                                      headers: {
                                        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                                      },
                                    })
                                    .then((res) => setPaqueterias(res.data || []))
                                    .catch(() => setPaqueterias([]));
                                }
                                setModalEditInfo(true);
                              }}
                            >
                              <i className="far fa-edit"></i>
                            </Button>
                          </td>
                          <td>
                              <div>
                                <Button
                                  size="sm"
                                  className="btn"
                                  color="danger"
                                  onClick={(e) =>
                                    PDFOC(
                                      a.fecha,
                                        a.colaboradores,
                                        a.idClientes,
                                        a.clientes,
                                        a.total_cantidad,
                                        a.total_general,
                                        a.observaciones,
                                        a.numero,
                                        a.impuestos,
                                        a.comisionFlete,
                                        a.comisionTDC,
                                        a._id,
                                        a.calle,
                                        a.numero_ext,
                                        a.numero_int,
                                        a.pais,
                                        a.estado,
                                        a.ciudad,
                                        a.delegacion,
                                        a.colonia,
                                        a.cp,
                                        a.RFC,
                                        a.paqueteria,
                                        a.codigoClientes,
                                        a.autorizadoApartado,
                                        a.autorizadoSurtido,
                                        a.telefono,
                                        a.editado,
                                        a.editPedido,
                                        a.autorizoApartado,
                                        a.autorizoSurtido
                                    )
                                  }
                                >
                                  <i class="far fa-file-pdf"></i>
                                </Button>

                                {/* Ver el pedido en un modal sin descargarlo */}
                                <Button
                                  size="sm"
                                  className="btn"
                                  color="info"
                                  title="Ver pedido"
                                  onClick={() => PDFOC(...argsPDFOC(a), true)}
                                >
                                  <i class="far fa-eye"></i>
                                </Button>

                                {/* PDF de peso de lo pendiente por surtir */}
                                <Button
                                  size="sm"
                                  className="btn"
                                  color="warning"
                                  title="PDF de Peso"
                                  onClick={() =>
                                    PDFPeso(a._id, a.numero, a.clientes, a.fecha, a.estado)
                                  }
                                >
                                  <i class="fas fa-weight-hanging"></i>
                                </Button>

                                <Button
                                  size="sm"
                                  className="btn"
                                  color="primary"
                                  onClick={(e) =>
                                    excelOC(
                                      a._id,
                                      a.clientes,
                                    )
                                  }
                                >
                                  <i class="far fa-file-excel"></i>
                                </Button>

                                {/* Regresar a azul: vuelve a quedar pendiente de imprimir */}
                                {(a.pdfImpreso === "Si" || a.editado === "Si") && (
                                  <>
                                    <Button
                                      size="sm"
                                      className="btn"
                                      outline
                                      color="info"
                                      id={`azul-${a._id}`}
                                      style={{ backgroundColor: "#fff" }}
                                      onClick={() => regresarAAzul(a)}
                                    >
                                      <i class="fas fa-fill-drip"></i>
                                    </Button>
                                    <UncontrolledTooltip placement="top" target={`azul-${a._id}`}>
                                      Regresar a azul (pendiente de imprimir)
                                    </UncontrolledTooltip>
                                  </>
                                )}

                              </div>
                          </td>
                          <td>
                          {a.surtido == "No" ? (
                            <Button
                              color="info"
                              id="Editar"
                              size="sm"
                              onClick={(e) =>
                                seleccionarPedido(
                                  a._id,
                                  a.numero,
                                  a.idClientes,
                                  a.clientes,
                                  a.codigo,
                                  a.impuestos,
                                  a.comisionFlete,
                                  a.comisionTDC,
                                  a.descuento,
                                  a.idColaboradores,
                                  a.alertasVentas,
                                  a.telefono,
                                  a.colaboradores,
                                  a.calle,
                                  a.numero_ext,
                                  a.numero_int,
                                  a.estado,
                                  a.ciudad,
                                  a.delegacion,
                                  a.colonia,
                                  a.cp,
                                  a.paqueteria,
                                  a.RFC,
                                )
                              }
                            >
                              <i class="fas fa-shipping-fast"></i>
                            </Button>
                          ):undefined}
                          </td>
                          <td>
                            <StatusMultipleSurtido
                              idStatus={a._id}
                              status={a.surtido}
                              URL_STATUS={URL_PEDIDOS}
                              hijo={`${URL_ARTICULOS_PEDIDO}/baja`}
                            />
                          </td>
                        </tr>
                      );
                    }
                  })}
                </tbody>
              </Table>
              <div className="col-md-6">
                <Pagination
                  total={totalItems}
                  itemsPerPage={ITEMS_PER_PAGE}
                  currentPage={currentPage}
                  onPageChange={(page) => setCurrentPage(page)}
                />
              </div>
            </div>
          ) : (
            // Termina Abrir Surtir
            <div className="card container col-md-12">
              <h4 style={{ marginTop: 10 }}>
                Surtir Pedido {numero_pedido}
                <span style={{ fontWeight: 400, color: "#555" }}> · {clientesName}</span>
              </h4>

              <Form onSubmit={saveSurtidos}>
                <Row>
                  <Col md={2}>
                    <Label>Fecha</Label>
                    <Input
                      type="date"
                      placeholder="Fecha"
                      value={fecha}
                      required
                      disabled
                    />
                  </Col>

                  <Col md={2}>
                  <Label>Flete</Label>
                    <Input
                      type="number"
                      placeholder="Flete"
                      value={comisionFlete}
                      required
                      onChange={(e) => {
                        setComisionFlete(e.target.value);
                      }}
                    />
                  </Col>

                  {/* <Col md={2}>
                    <Label>Impuestos %</Label>
                     <Input
                    type="select"
                    value={impuestos}
                    required
                    // onChange={(e) => {
                    //   setImpuestos(e.target.value);
                    // }}
                    disabled
                  >
                    <option value="">Selecciona</option>
                    <option value="16">Si</option>
                    <option value="0">No</option>
                </Input>
                  </Col>


                  <Col md={2}>
                    <Label>Descuento %</Label>
                    <Input
                      type="number"
                      value={descuento}
                      required
                      disabled
                    />
                  </Col> */}

                  <Col md={4}>
                    <Label for="exampleEmail" className="mr-sm-2">
                      Observaciones
                    </Label>
                    <Input
                      type="text"
                      placeholder="Observaciones"
                      value={observaciones}
                      required
                      onChange={(e) => {
                        setObservaciones(e.target.value);
                      }}
                    />
                  </Col>
                {/* </Row>
                <Row> */}
                  <Col md={2}>
                    <Label for="exampleEmail" className="mr-sm-2">
                     Salida Bodega
                    </Label>
                    <Input
                      type="text"
                      placeholder="Salida Bodega"
                      value={salidaBodega}
                      required
                      onChange={(e) => {
                        setSalidaBodega(e.target.value);
                      }}
                    />
                  </Col>
                  <Col md={2}>
                    <Label>Vendedor</Label>
                    <Input
                      type="select"
                      value={selectedColaboradorSurtido}
                          onChange={(e) => {
                        setSelectedColaboradorSurtido(e.target.value);
                      }}
                    >
                      <option value="">Selecciona un Vendedor</option>
                      {colaboradores
                        .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                        .map((a) => {
                          return (
                            <option value={a._id}>
                              {a.nombre} {a.apellido}
                            </option>
                          );
                        })}
                    </Input>
                  </Col>
                  {/* <Col md={2}>
                    <Label>Comision TDC</Label>
                    <CurrencyInput
                      intlConfig={{ locale: "en-US", currency: "USD" }}
                      prefix="$"
                      defaultValue={0}
                      decimalsLimit={2}
                      value={comisionTDC}
                      className={`form-control`}
                      // onValueChange={(value) => {
                      //   setComisionTDC(value);
                      // }}
                      disabled
                    />
                  </Col>
                  <Col md={2}>
                    <Label>Plazo</Label>
                    <Input
                      type="select"
                      placeholder="Plazo"
                      value={plazo}
                      required
                      onChange={(e) => {
                        setPlazo(e.target.value);
                      }}
                    >
                      <option value="">Plazo</option>
                      <option value="0">0</option>
                  <option value="15">15</option>
                      <option value="30">30</option>
                      <option value="60">60</option>
                      <option value="90">90</option>
                      <option value="120">120</option>
                      <option value="150">150</option>
                      <option value="180">180</option>
                    </Input>
                  </Col> */}
                </Row>

                <br />
                {/* Tabla Articulos: encabezado fijo arriba y totales fijos abajo,
                    para que al bajar en un pedido largo siempre se vean los títulos */}
                <div className="tablaSurtirScroll">
                  <Table size="sm" hover className="mb-0 tablaSurtir">
                    <thead>
                      <tr>
                        <th>Código</th>
                        <th>Modelo</th>
                        <th className="num">Inventario</th>
                        <th className="num">Pedido</th>
                        <th className="num">Pendiente</th>
                        <th className="num" style={{ width: 120 }}>Surtir (pzas)</th>
                        <th className="num" style={{ width: 100 }}>Cajas</th>
                        <th className="num">Pzas/caja</th>
                      </tr>
                    </thead>
                    <tbody>
                      {inputFields.map((inputField) => {
                        const cant = parseFloat(inputField.cantidad) || 0;
                        const pend = parseFloat(inputField.pendSurtir) || 0;
                        const inv = parseFloat(inputField.cantInv) || 0;
                        const corto = cant < pend;
                        const sinPrecioLinea = pend > 0 && !(Number(inputField.precio) > 0);
                        return (
                          <tr key={inputField.id}>
                            <td className="codigo">
                              {inputField.articuloCodigo}
                              {sinPrecioLinea ? (
                                <span className="badgeCero" title="Sin precio: no se va a poder surtir">$0</span>
                              ) : null}
                            </td>
                            <td className="modelo">{inputField.articuloNombre}</td>
                            <td
                              className={inv < pend ? "num faltaInv" : "num"}
                              title={inv < pend ? "No alcanza el inventario para todo lo pendiente" : undefined}
                            >
                              {new Intl.NumberFormat("en-US").format(inv)}
                            </td>
                            <td className="num">{new Intl.NumberFormat("en-US").format(parseFloat(inputField.cantPed) || 0)}</td>
                            <td className="num">{new Intl.NumberFormat("en-US").format(pend)}</td>
                            <td>
                              <Input
                                bsSize="sm"
                                name="cantidad"
                                type="number"
                                min="0"
                                step="any"
                                value={inputField.cantidad}
                                required
                                onChange={(event) => handleChangeInputCantidad(inputField.id, event)}
                                // La rueda del mouse sobre un número lo cambia: al bajar en la lista se movían cantidades
                                onWheel={(e) => e.currentTarget.blur()}
                                className={corto ? "inputSurtir corto" : "inputSurtir"}
                              />
                            </td>
                            <td>
                              <Input
                                bsSize="sm"
                                name="cajas"
                                type="number"
                                min="0"
                                step="any"
                                value={inputField.cajas}
                                onChange={(event) => handleChangeInputCantidadCajas(inputField.id, event)}
                                onWheel={(e) => e.currentTarget.blur()}
                                className="inputSurtir"
                              />
                            </td>
                            <td className="num tenue">{inputField.piezasPorCaja}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                    <tfoot>
                      <tr>
                        <td colSpan={5} className="num">
                          TOTALES · {inputFields.length} artículos
                        </td>
                        <td className="num">{new Intl.NumberFormat("en-US").format(total)} pzas</td>
                        <td className="num">
                          {new Intl.NumberFormat("en-US", { maximumFractionDigits: 2 }).format(parseFloat(totalCajas) || 0)} cajas
                        </td>
                        <td></td>
                      </tr>
                    </tfoot>
                  </Table>
                </div>
                {/* Termina Tabla Articulos */}

                <div style={{ marginTop: 12 }} />
                {validaBoton ? (
                  <Button type="submit" className="btn btn-success">
                    Surtir
                  </Button>
                ) : (
                  <Button type="submit" className="btn btn-success" disabled>
                    Surtir
                  </Button>
                )}
                <Button
                  onClick={(e) => setAbrirSurtir(false)}
                  className="btn btn-danger"
                  id="botonListado"
                >
                  Regresar
                </Button>
              </Form>
            </div>
          )}
        </div>
      ) : undefined}
      <br />

     <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
             <h4> Este proceso puede tardar varios segundos.
              <br />
              Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                  <Spinner
                    style={{
                      width: "50px",
                      height: "50px",
                      color: "#232B41",
                    }}
                  />
                  <Spinner
                    style={{
                      width: "50px",
                      height: "50px",
                      color: "#232B41",
                    }}
                  />
                  <Spinner
                    style={{
                      width: "50px",
                      height: "50px",
                      color: "#232B41",
                    }}
                  />
              </div>
            </ModalBody>
          </Modal>

          <Modal size="sm" isOpen={modalAreaSurtir} toggle={toggleAreaSurtir}>
            <ModalHeader toggle={toggleAreaSurtir}>
              <h4>Surtir Pedido {numero_pedido}</h4>
            </ModalHeader>
            <ModalBody>
           <Row>
            <Col md={6}>
            <Label>Almacen</Label>
            <Input
            type="select"
            value={selectedArea}
            required
            onChange={(event) => setSelectedArea(event.target.value)}
            >
             <option value="">Selecciona</option>
                    {areas
                      .sort((a, b) =>
                        a.name > b.name ? 1 : -1
                      )
                      .map((a) => {
                        return (
                          <option value={a._id}>{a.name}</option>
                        );
                      })}
            </Input>
            </Col>

            <Col md={6}>
            <Label>Empresa</Label>
            <Input
            type="select"
            value={selectedEmpresa}
            required
            onChange={(event) => setSelectedEmpresa(event.target.value)}
            >
             <option value="">Selecciona</option>
                    {empresas
                      .sort((a, b) =>
                        a.name > b.name ? 1 : -1
                      )
                      .map((a) => {
                        return (
                          <option value={a._id}>{a.name}</option>
                        );
                      })}
            </Input>
            </Col>
            <Col md={6}>
              <Label>Sucursal de entrega</Label>
              <Input
                type="select"
                value={selectedSucursal}
                onChange={(e) => setSelectedSucursal(e.target.value)}
              >
                <option value="">Selecciona</option>
                {sucursalesCliente
                  .sort((a, b) => (a.alias > b.alias ? 1 : -1))
                  .map((s) => (
                    <option key={s._id} value={s._id}>{s.alias || s.calle}</option>
                  ))}
              </Input>
            </Col>
            <Col md={6}>
              <Label>Paqueteria</Label>
              <Input
                type="select"
                value={selectedPaqueteria}
                onChange={(e) => setSelectedPaqueteria(e.target.value)}
              >
                <option value="">Selecciona</option>
                {paqueterias
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((p) => (
                    <option key={p._id} value={p._id}>{p.name}</option>
                  ))}
              </Input>
            </Col>

           </Row>
           {selectedArea !== "" && selectedEmpresa !== "" && selectedSucursal !== "" && selectedPaqueteria !== "" ? (
             <Button type="submit" className="btn btn-success" onClick={e=>{jalaArticulos()}}>
               Surtir
             </Button>
           ) : (
             <>
               <Button disabled type="submit" className="btn btn-success">
                 Surtir
               </Button>
               <div style={{ color: "#911c04", marginTop: 8, fontSize: 12 }}>
                 Selecciona Almacén, Empresa, Sucursal de entrega y Paquetería para continuar.
               </div>
             </>
           )}
            </ModalBody>
          </Modal>

      {/* W4: Modal editar paqueteria/fecha programada inline */}
      <Modal isOpen={modalEditInfo} toggle={() => setModalEditInfo(!modalEditInfo)}>
        <ModalHeader toggle={() => setModalEditInfo(!modalEditInfo)}>
          Editar paqueteria / fecha programada
        </ModalHeader>
        <ModalBody>
          <Label>Paqueteria</Label>
          <Input
            type="select"
            value={editInfoPaqueteria}
            onChange={(e) => setEditInfoPaqueteria(e.target.value)}
          >
            <option value="">Selecciona</option>
            {paqueterias
              .filter((p) => p.is_active !== "No")
              .sort((a, b) => (a.name > b.name ? 1 : -1))
              .map((p) => (
                <option key={p._id} value={p.name}>{p.name}</option>
              ))}
          </Input>
          <br />
          <Label>Fecha Programada</Label>
          <Input
            type="date"
            value={editInfoFechaProg}
            onChange={(e) => setEditInfoFechaProg(e.target.value)}
          />
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setModalEditInfo(false)}>Cancelar</Button>
          <Button
            color="success"
            onClick={async () => {
              try {
                await axios.patch(
                  `${URL_PEDIDOS}/${editInfoPedidoId}`,
                  { paqueteria: editInfoPaqueteria, fecha_programada: editInfoFechaProg },
                  { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
                );
                setComments((prev) => prev.map((c) =>
                  c._id === editInfoPedidoId
                    ? { ...c, paqueteria: editInfoPaqueteria, fecha_programada: editInfoFechaProg }
                    : c
                ));
                setModalEditInfo(false);
                Swal.fire({ icon: "success", title: "Actualizado", timer: 1200, showConfirmButton: false });
              } catch (err) {
                Swal.fire({ icon: "error", title: "Error", text: "No se pudo actualizar" });
              }
            }}
          >
            Guardar
          </Button>
        </ModalFooter>
      </Modal>

      {loader}
    </>
  );
}

export default ListadoPendienteSurtir;
